import { initializeApp } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js";
import { 
    getFirestore, collection, addDoc, deleteDoc, doc, getDocs, 
    orderBy, query, updateDoc, arrayUnion, arrayRemove, getDoc, 
    where, setDoc, limit, startAfter, increment ,serverTimestamp
} from "https://www.gstatic.com/firebasejs/10.7.1/firebase-firestore.js";
import { getStorage, ref, uploadBytes, getDownloadURL } from "https://www.gstatic.com/firebasejs/10.7.1/firebase-storage.js";
// 🚀 [추가됨] 분리된 Q&A 전용 로직 파일 불러오기
import { 
  initQnaLogic, openQnA, openQnaDetail, closeQnaDetail, openQnaEditor, 
  closeQnaEditor, selectQnaCategory, previewQnaImages, removeQnaImage, 
  submitQnaPost, editQnaPost, removeExistingQnaImage, deleteQnaPost, 
  loadQnaList, changeQnaTab, submitQnaComment, editQnaComment, deleteQnaComment, 
  prepareReply, selectBestAnswer, openProductSearch, closeQnaProductSearch, 
  searchShopifyProducts, selectProduct, clearSelectedProduct, loadQnaComments, 
  loadUserQnaStats, initQnaEvents 
} from "./qna-logic.js"; // ⬅️ asset 파일명과 동일하게 맞춤
// 🚀 [추가됨] 에디터 전용 로직 파일 불러오기
import {
  initEditorLogic, openWritePage, openEditor, editPost, checkUploadState,
  submitPost, renderMediaSection, createSection, removeSection, handleImageClick,
  confirmSelection, handleSyncHover, initPinObserver, handleDescInput,
  syncScroll, insertHashtag, removeTagAndPin, clearPins, toggleAccordion,
  toggleOtherInput, toggleGhostInput, simpleGhostPreview, removeGhostAvatar,
  initEditorEvents
} from "./editor-logic.js";
/* ==========================================================================
   SECTION 1. CONFIG & GLOBAL STATE
   - Firebase 초기화, 전역 변수, 상수 정의
   ========================================================================== */

// [관리자 명단]
window.ADMIN_EMAILS = ["wogkr24@naver.com", "yoreum98ee@gmail.com", "hono1298@gmail.com", "furnihunter@gmail.com", "nam@furnihunter.com"];

// 💡 [최상단에 추가] 페이지 유형 감별 및 전역 에러 방지
const isQnaPage = window.location.pathname.includes('qna');
// [community-script.js 최상단 추가]
if (isQnaPage) {
    // 💡 갤러리 페이지가 아니면 아래 함수들이 아무 일도 하지 않게 '멍청이' 함수로 만듭니다.
    // 이렇게 하면 485번 줄 같은 에러가 발생하지 않아 코드가 끝까지 실행됩니다.
    window.applyFilters = () => {};
    window.loadGallery = () => {};
    window.updateBestInteriors = () => {};
    window.loadMonthlyBest = () => {};
    
    // 에러 방지용 가짜 요소 객체 생성 (Optional)
    if (!document.getElementById('filterDateStart')) {
        console.log("ℹ️ Q&A 모드: 갤러리 에러 방어막 활성화");
    }
}
// 갤러리 전용 요소들을 안전하게 찾는 헬퍼 함수
const getSafeEl = (id) => document.getElementById(id) || { classList: { add: () => {}, remove: () => {} }, style: {} };


const firebaseConfig = {
apiKey: "AIzaSyA2UxM1a1Muy7PquZPP3pc6QyU4PAXwjF0",
authDomain: "furnihunter-community-jp.firebaseapp.com",
projectId: "furnihunter-community-jp",
storageBucket: "furnihunter-community-jp.firebasestorage.app",
messagingSenderId: "573529217034",
appId: "1:573529217034:web:c6d6a407e49d06e1ce27f3",
measurementId: "G-LEMD9XJJNB"
};
//전역변수
const currentUser = window.ShopifyInfo.currentUser;
const currentUserId = window.ShopifyInfo.currentUserId ? String(window.ShopifyInfo.currentUserId) : null;
const MAX_VIDEO_SIZE = 50 * 1024 * 1024; 
const MAX_IMAGE_SIZE = 20 * 1024 * 1024; 
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const currentFilters = {
  sort: 'newest',
  following: false,
  video: false,
  structure: 'all',
  size: 'all',
  startDate: '',
  endDate: ''
};
window.db = db;
// ==============================================================
// 🚀 [추가됨] Q&A 모듈 초기화 및 HTML 연동 (window 객체 매핑)
// ==============================================================
// 1. Q&A 모듈에 Firebase DB와 현재 로그인 유저 정보 전달
initQnaLogic(db, storage, currentUserId);

// 2. HTML 인라인 이벤트(onclick)에서 부를 수 있도록 window에 등록
window.openQnA = openQnA;
window.openQnaDetail = openQnaDetail;
window.closeQnaDetail = closeQnaDetail;
window.openQnaEditor = openQnaEditor;
window.closeQnaEditor = closeQnaEditor;
window.selectQnaCategory = selectQnaCategory;
window.previewQnaImages = previewQnaImages;
window.removeQnaImage = removeQnaImage;
window.submitQnaPost = submitQnaPost;
window.editQnaPost = editQnaPost;
window.removeExistingQnaImage = removeExistingQnaImage;
window.deleteQnaPost = deleteQnaPost;
window.loadQnaList = loadQnaList;
window.changeQnaTab = changeQnaTab;
window.submitQnaComment = submitQnaComment;
window.editQnaComment = editQnaComment;
window.deleteQnaComment = deleteQnaComment;
window.prepareReply = prepareReply;
window.selectBestAnswer = selectBestAnswer;
window.openProductSearch = openProductSearch;
window.closeQnaProductSearch = closeQnaProductSearch;
window.searchShopifyProducts = searchShopifyProducts;
window.selectProduct = selectProduct;
window.clearSelectedProduct = clearSelectedProduct;
window.loadQnaComments = loadQnaComments;
window.loadUserQnaStats = loadUserQnaStats;

// ==============================================================
// 🚀 [추가됨] 에디터 모듈 초기화 및 HTML 연동
// ==============================================================
initEditorLogic(db, storage, currentUserId, MAX_VIDEO_SIZE, MAX_IMAGE_SIZE);

// 이벤트 리스너 실행
document.addEventListener('DOMContentLoaded', () => {
    initQnaEvents(); // 기존 QnA
    initEditorEvents(); // ★ 에디터 파일 첨부 이벤트
});

// HTML 인라인용 window 객체 맵핑
window.openWritePage = openWritePage;
window.openEditor = openEditor;
window.editPost = editPost;
window.checkUploadState = checkUploadState;
window.submitPost = submitPost;
window.renderMediaSection = renderMediaSection;
window.createSection = createSection;
window.removeSection = removeSection;
window.handleImageClick = handleImageClick;
window.confirmSelection = confirmSelection;
window.handleSyncHover = handleSyncHover; // 상세 갤러리에서도 쓰임
window.initPinObserver = initPinObserver; // 상세 갤러리에서도 쓰임
window.handleDescInput = handleDescInput;
window.syncScroll = syncScroll;
window.insertHashtag = insertHashtag;
window.removeTagAndPin = removeTagAndPin;
window.clearPins = clearPins;
window.toggleAccordion = toggleAccordion;
window.toggleOtherInput = toggleOtherInput;
window.toggleGhostInput = toggleGhostInput;
window.simpleGhostPreview = simpleGhostPreview;
window.removeGhostAvatar = removeGhostAvatar;

// 3. Q&A 전용 이벤트 리스너 실행 (바깥 터치 닫기 등)
document.addEventListener('DOMContentLoaded', () => {
    initQnaEvents();
});

// 유틸 함수
// ID를 주소창용으로 변환 (Base64)
const maskId = (id) => {
    try { return btoa(unescape(encodeURIComponent(id))); } 
    catch(e) { return id; }
};
// 주소창의 값을 실제 ID로 복구
const unmaskId = (encoded) => {
    try { return decodeURIComponent(escape(atob(encoded))); } 
    catch(e) { return encoded; }
};
const getIcon = (name) => {
  if(name === 'heart') return `<svg class="fh-svg-icon" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
  if(name === 'comment') return `<svg class="fh-svg-icon" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>`;
  if(name === 'bookmark') return `<svg class="fh-svg-icon" viewBox="0 0 24 24"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>`;
  if(name === 'reply') return `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 10h10a5 5 0 0 1 5 5v6M3 10l6-6M3 10l6 6"/></svg>`;
  if(name === 'heart-small') return `<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>`;
  return '';
}
// [보조] 날짜 포맷팅 함수
function formatDate(isoDate) {
    try {
        const d = new Date(isoDate);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hour = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${month}.${day} ${hour}:${min}`;
    } catch { return "-"; }
}
function hideLoader() {
  const loader = document.getElementById('globalLoader');
  if(loader) {
      loader.style.opacity = '0';
      setTimeout(() => { loader.style.display = 'none'; }, 400); 
  }
}

window.allPosts = []; 
window.fhProducts = []; 
window.globalHashtags = new Set(); 
let currentPostId = null; 
let lastCommentSnapshot = null; 
let editingPostId = null; 
let searchKeyword = ""; 

// [Global State] 데이터 캐싱 및 상태 관리
window.allFetchedPosts = []; //전체게시글 원본데이터
window.allCommentsCache = []; //댓글 페이지용 캐시
window.commentsPerPage = 10; //댓글 페이지당 개수
window.isGalleryLoading = false; //중독로딩 방지 플래그

// [Editor State] 에디터 관련 전역 변수
window.taggingStates = {}; 
window.currentSectionId = null; 
window.tempCoords = null; 

// [수정] 첫 접속 시에만 인트로 실행
window.addEventListener('load', () => {
    const intro = document.getElementById('fh-intro-overlay');
    if (!intro) return;

    if (!sessionStorage.getItem('intro_seen')) {
        setTimeout(() => {
            intro.classList.add('fh-intro-hidden');
            sessionStorage.setItem('intro_seen', 'true');
            setTimeout(() => { intro.style.display = 'none'; }, 800);
        }, 1800);
    } else {
        intro.style.display = 'none';
    }
    
    // 타이핑 효과 실행
    startTypingEffect();
    renderAuthButtons();
}); 

// [Silent Refresh]
window.addEventListener('pageshow', async function(event) {
    renderAuthButtons(); 
    if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
        console.log("Silent Refresh");
        if(currentUserId) await silentRefresh();
    }
});

async function syncUserToFirebase() {
  if (!currentUserId) return; 
  // [수정] ID를 문자열로 변환하여 Firebase 에러 방지
  const userRef = doc(db, "users", String(currentUserId)); 
  
  try {
    await setDoc(userRef, {
      name: currentUser,
      id: String(currentUserId), // 필드에 저장되는 ID도 문자열로 통일하는 것이 좋습니다.
      lastSeen: new Date().toISOString()
    }, { merge: true });
  } catch (e) { console.error("Sync Error:", e); }
}
syncUserToFirebase();

setInterval(() => {
  // 브라우저 탭을 열어보고 있을 때만 갱신 (데이터 절약)
  if (document.visibilityState === 'visible' && currentUserId && currentUserId !== 'Guest') {
      syncUserToFirebase();
  }
}, 120000); // 120,000ms = 2분


/* ==========================================================================
   SECTION 2. INIT & ROUTING
   - 페이지 로드 이벤트, 인트로, 주소창 감지, 뒤로가기 처리
   ========================================================================== */   
window.addEventListener('load', async () => {
    if (currentUserId && currentUserId !== 'Guest') {
      try {
          const mySnap = await getDoc(doc(db, "users", String(currentUserId)));
          if (mySnap.exists()) window.currentUserFollowing = (mySnap.data().following || []).map(id => String(id));
      } catch(e) {}
  }
  const urlParams = new URLSearchParams(window.location.search);
  const targetPostId = urlParams.get('post_id');
  const rawProfileId = urlParams.get('profile_id');
  const targetProfileId = rawProfileId ? unmaskId(rawProfileId) : null;

  document.addEventListener('click', (e) => {
    if(!e.target.closest('.fh-dropdown')) {
      document.querySelectorAll('.fh-dropdown').forEach(d => d.classList.remove('open'));
    }
    if(!e.target.closest('.fh-post-menu-wrap')) {
       const menu = document.getElementById('postMenuDropdown');
       if(menu) menu.classList.remove('show');
    }
    if(e.target.classList.contains('fh-mobile-backdrop')) {
        closeAllDropdowns();
    }
    if(!e.target.closest('.fh-desc-wrapper')) {
        document.querySelectorAll('.fh-tag-suggestions').forEach(s => s.style.display = 'none');
    }
  });

  if (targetPostId) {
      currentPostId = targetPostId;
      await loadSinglePost(targetPostId);
  } else if (targetProfileId) {
      await loadUserProfile(targetProfileId);
  } else {
      await loadGallery();
      hideLoader();
  }
});

// [최종 통합] 모든 페이지 뒤로가기 & 라우팅 통합 관제탑
window.addEventListener('popstate', function(event) {
    const urlParams = new URLSearchParams(window.location.search);
    const qnaPostId = urlParams.get('id'); 
    const postId = urlParams.get('post_id'); 
    const profileId = urlParams.get('profile_id');
    const hash = window.location.hash;

    const qnaView = document.getElementById('qnaView');
    const qnaDetailView = document.getElementById('qnaDetailView');
    const galleryView = document.getElementById('galleryView');
    const editorView = document.getElementById('editorView');
    const qnaWriteBtn = document.getElementById('fabQnaWriteBtn');

    if (window.location.pathname.includes('qna')) {
        if (qnaPostId) {
            if (typeof window.openQnaDetail === 'function') {
                window.openQnaDetail(qnaPostId, true);
            }
        } else {
            if (qnaDetailView) {
                qnaDetailView.classList.add('hidden');
                qnaDetailView.style.setProperty('display', 'none', 'important'); 
            }
            if (qnaView) {
                qnaView.classList.remove('hidden');
                qnaView.style.setProperty('display', 'block', 'important');
            }

            const titleWrap = document.querySelector('.fh-title-wrapper');
            const mainHeader = document.getElementById('mainHeader');
            if(titleWrap) titleWrap.style.display = 'block';
            if(mainHeader) {
                mainHeader.style.display = 'flex';
                // 🚨 [추가] QnA에서도 뒤로가기 시 메뉴바 강제 하강!
                mainHeader.style.transform = 'translateY(0)'; 
            }
            document.querySelector('.fh-present-bar')?.removeAttribute('style');

            if (qnaWriteBtn) qnaWriteBtn.style.display = 'flex';
        }
        window.scrollTo(0, 0);
        return;
    }

    if (hash === '#write') {
        if (editorView?.classList.contains('hidden')) {
            if (typeof openWritePage === 'function') openWritePage();
        }
        return;
    }

    if (postId) {
        if (typeof openPostDetail === 'function') openPostDetail(postId, false);
        else if (typeof loadSinglePost === 'function') loadSinglePost(postId);
        editorView?.classList.add('hidden');
    } else if (profileId) {
        if (typeof loadUserProfile === 'function') loadUserProfile(maskId(profileId, true));
        editorView?.classList.add('hidden');
    } else {
        document.getElementById('detailView')?.classList.add('hidden');
        document.getElementById('userProfileView')?.classList.add('hidden');
        editorView?.classList.add('hidden');
        
        if (galleryView) {
            galleryView.classList.remove('hidden');
            galleryView.style.display = '';
        }
        document.getElementById('filterBar')?.classList.remove('hidden');

        const presentBar = document.querySelector('.fh-present-bar');
        const titleWrap = document.querySelector('.fh-title-wrapper');
        const mainHeader = document.getElementById('mainHeader');
        const searchWrap = document.querySelector('.fh-search-wrapper');

        if(presentBar) presentBar.style.display = '';
        if(titleWrap) titleWrap.style.display = '';
        if(searchWrap) searchWrap.style.display = '';
        if(mainHeader) {
            mainHeader.style.display = '';
            mainHeader.classList.remove('hidden');
            // 🚨 [추가] 천장에 붙어버린 메뉴바 강제로 멱살 잡고 끌어내리기!
            mainHeader.style.transform = 'translateY(0)'; 
            if(typeof window.renderAuthButtons === 'function') window.renderAuthButtons(); 
        }
        
        // 🚨 [추가] 모바일 전용 끈적이 헤더가 있다면 같이 끌어내리기
        const mobileHeader = document.getElementById('mobileStickyHeader');
        if (mobileHeader) mobileHeader.style.transform = 'translateY(0)';
    }
});

window.addEventListener('hashchange', function() {
    if (window.location.hash !== '#write') {
        const editor = document.getElementById('editorView');
        if (editor && !editor.classList.contains('hidden')) {
            editor.classList.add('hidden');
            document.getElementById('galleryView').classList.remove('hidden');
            document.getElementById('filterBar').classList.remove('hidden');

            // 🚨 [추가] 글쓰기 창에서 뒤로가기 눌렀을 때도 메뉴바 강제 복구!
            const mainHeader = document.getElementById('mainHeader');
            if(mainHeader) {
                mainHeader.style.display = '';
                mainHeader.classList.remove('hidden');
                mainHeader.style.transform = 'translateY(0)';
            }
        }
    }
});

// 타이핑 효과 함수 분리
function startTypingEffect() {
    const textElement = document.getElementById('fh-typing-text');
    if(!textElement) return;
    
    const phrases = [
        "FURNIHUNTER PRESENTS",
        "FIND YOUR INSPIRATION",
        "SHARE YOUR ROOM STYLE",
        "CONNECT WITH CREATORS"
    ];
    
    let phraseIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let typeSpeed = 100;

    function typeEffect() {
        const currentPhrase = phrases[phraseIndex];
        if (isDeleting) {
            textElement.textContent = currentPhrase.substring(0, charIndex - 1);
            charIndex--;
            typeSpeed = 50;
        } else {
            textElement.textContent = currentPhrase.substring(0, charIndex + 1);
            charIndex++;
            typeSpeed = 100;
        }

        if (!isDeleting && charIndex === currentPhrase.length) {
            isDeleting = true;
            typeSpeed = 2000; 
        } else if (isDeleting && charIndex === 0) {
            isDeleting = false;
            phraseIndex = (phraseIndex + 1) % phrases.length;
            typeSpeed = 500;
        }
        setTimeout(typeEffect, typeSpeed);
    }
    typeEffect();
}


window.renderAuthButtons = function() {
  const container = document.getElementById('headerAuthButtons');
  if(!container) return;

  if(currentUserId && currentUserId !== 'Guest') {
      // 로그인 한 유저 (글쓰기 + 마이페이지 표시)
      container.innerHTML = `
          <div class="fh-quick-item" onclick="openEditor()">
              <div class="fh-quick-icon bg-black">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4"></path></svg>
              </div>
              <span class="fh-quick-text">投稿する</span>
          </div>
          
          <div class="fh-quick-item" onclick="location.href='${window.ShopifyInfo.mypageUrl}'">
              <div class="fh-quick-icon bg-gray">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
              </div>
              <span class="fh-quick-text">My Page</span>
          </div>
      `;
  } else {
      // 로그인 안 한 게스트 (Login 버튼만 표시)
      container.innerHTML = `
          <div class="fh-quick-item" onclick="location.href='${window.ShopifyInfo.loginUrl}'">
              <div class="fh-quick-icon bg-black">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3"></path></svg>
              </div>
              <span class="fh-quick-text">Login</span>
          </div>
      `;
  }
}

// [Silent Refresh] 팔로잉 목록 가져오기 및 UI 동기화
async function silentRefresh() {
    if (!currentUserId) return;
    try {
        const userDoc = await getDoc(doc(db, "users", currentUserId));
        if(!userDoc.exists()) return;
        
        const myData = userDoc.data();
        // ID 문자열 변환
        const rawFollowing = myData.following || [];
        window.currentUserFollowing = rawFollowing.map(id => String(id));

        // 화면에 있는 모든 팔로우 버튼 찾아서 상태 업데이트
        const allButtons = document.querySelectorAll('button[data-userid]');
        allButtons.forEach(btn => {
            const targetId = String(btn.dataset.userid);
            if(targetId === currentUserId) return;
            
            const isFollowing = window.currentUserFollowing.includes(targetId);
            updateFollowButtonUI(btn, isFollowing); // 위에서 만든 함수 사용
        });
    } catch(e) { console.error("Silent Refresh Error:", e); }
}

/* ==========================================================================
   SECTION 3. DATA FETCHING (READ)
   - DB에서 데이터를 가져오는 함수들
   ========================================================================== */

// 📢 1. 공지사항 숫자 가져와서 배지 띄우기
async function initNoticeBadge() {
    const badgeEl = document.getElementById('noticeBadge');
    // 게스트이거나 배지 요소가 없으면 실행 안 함
    if (!badgeEl || !window.currentUserId || window.currentUserId === 'Guest') return;

    try {
        // 유저의 마지막 확인 시간 가져오기 (없으면 1970년으로 세팅해서 전부 다 가져오게 함)
        const userRef = doc(db, "users", String(window.currentUserId));
        const userSnap = await getDoc(userRef);
        const lastViewed = userSnap.exists() ? (userSnap.data().lastNoticeViewed || "1970-01-01T00:00:00Z") : "1970-01-01T00:00:00Z";

        // 마지막 확인 시간 이후에 작성된 공지사항만 카운팅
        const q = query(
            collection(db, "notices"), 
            where("createdAt", ">", lastViewed) 
        );
        
        const snap = await getDocs(q);
        const unreadCount = snap.size;

        // 안 읽은 게 1개 이상이면 배지 띄우기 (9개 넘어가면 9+ 로 표시)
        if (unreadCount > 0) {
            badgeEl.innerText = unreadCount > 9 ? "9+" : unreadCount;
            badgeEl.classList.remove('hidden');
        } else {
            badgeEl.classList.add('hidden'); // 0이면 무조건 숨김
        }
    } catch (e) {
        console.error("Notice Badge Error:", e);
    }
}

// 📢 2. 공지사항 버튼 클릭했을 때 실행되는 함수
window.handleNoticeClick = async function(event) {
    // 기존에 있던 이벤트 전파 방지 유지
    event.stopPropagation();

    const badgeEl = document.getElementById('noticeBadge');
    if (!window.currentUserId || window.currentUserId === 'Guest') return; // 게스트면 통과

    // ★ 유저가 누르자마자 즉시 빨간 배지부터 숨겨버림 (반응속도 최적화)
    if (badgeEl) badgeEl.classList.add('hidden');

    try {
        // 파이어베이스에 "이 유저 지금 방금 공지사항 확인했음" 이라고 시간 기록
        const userRef = doc(db, "users", String(window.currentUserId));
        await setDoc(userRef, {
            lastNoticeViewed: new Date().toISOString()
        }, { merge: true });
    } catch (e) {
        console.error("Notice Viewed Update Error:", e);
    }
    
    // a 태그의 href 이동은 브라우저가 알아서 진행하므로 따로 건드릴 필요 없음 ㅇㅇ
};

// 화면 로딩이 끝나면 배지 체크 함수 실행
document.addEventListener('DOMContentLoaded', () => {
    // 파이어베이스 연결 시간 고려해서 0.5초 뒤에 스윽 띄워줍니다
    setTimeout(initNoticeBadge, 500); 
});

// [수정] 데이터를 가져오는 메인 함수 부분
window.fetchPosts = async function() {
    try {
        // 1. Firebase에서 데이터 가져오기 (이미 작성된 로직)
        const q = query(collection(db, "posts"), where("isDeleted", "==", false));
        const querySnapshot = await getDocs(q);
        
        const posts = [];
        querySnapshot.forEach((doc) => {
            posts.push({ id: doc.id, ...doc.data() });
        });

        // 2. ★ 중요: 전역 변수에 데이터를 먼저 꽉 채워넣습니다.
        window.allFetchedPosts = posts;
        window.allPosts = posts;

       if (typeof window.renderMonthlyBest === 'function') {
         window.renderMonthlyBest(window.allFetchedPosts); // ★ 추가
       }
       if (typeof window.renderBestInterior === 'function') {
         window.renderBestInterior(window.allFetchedPosts);
       }

        // 4. 일반 갤러리 섹션을 필터와 함께 호출합니다.
        // 이때 데이터가 이미 window.allPosts에 있으므로 꼬이지 않습니다.
        applyFilters();

    } catch (e) {
        console.error("Error fetching posts: ", e);
    }
};
   
// [최적화된 loadGallery] 유저 정보 중복 호출 제거 버전
async function loadGallery() {
  if (!document.getElementById('gridContainer')) return;
  if (window.isGalleryLoading) return;
  window.isGalleryLoading = true;

  const container = document.getElementById('gridContainer');
  if(container) container.innerHTML = "";

  // 내 팔로잉 정보 미리 가져오기
  if(currentUserId && currentUserId !== 'Guest') {
      try {
          const mySnap = await getDoc(doc(db, "users", currentUserId));
          if(mySnap.exists()) window.currentUserFollowing = mySnap.data().following || [];
      } catch(e) { console.warn("My following info load failed", e); }
  }

  window.allFetchedPosts = []; 
  window.globalHashtags = new Set();

  try {
      // 1. 게시글 목록 가져오기 (최대 50개로 줄임 - 속도 향상)
      const q = query(collection(db, "posts"), orderBy("date", "desc"), limit(50));
      const snap = await getDocs(q);
      
      const posts = [];
      const userIdsToFetch = new Set(); // 중복되지 않는 유저 ID만 모을 집합

      snap.docs.forEach(docSnap => {
          const data = docSnap.data();
          if (data.isDeleted) return; // 삭제된 글 제외

          // 유저 ID 수집 (Set이라서 자동 중복 제거됨)
          if (data.userId) {
              userIdsToFetch.add(String(data.userId));
          }
          posts.push({ id: docSnap.id, ...data });
      });

      // 2. [핵심 최적화] 유저 정보 한 번에 병렬로 가져오기 (중복 제거됨)
      // 예: 글이 50개여도 작성자가 5명이면 5번만 호출함.
      const userMap = {}; 
      const userPromises = Array.from(userIdsToFetch).map(uid => 
          getDoc(doc(db, "users", uid)).then(userSnap => {
              if (userSnap.exists()) {
                  userMap[uid] = userSnap.data();
              }
          })
      );

      // 모든 유저 정보 로딩 기다리기
      await Promise.all(userPromises);

      // 3. 게시글 + 유저 정보 합치기
      posts.forEach(post => {
          const writerUser = userMap[String(post.userId)] || {};
          
          post.authorVerified = writerUser.isVerified === true; 
          post.authorNickname = writerUser.nickname || post.user || "Unknown"; 
          post.authorAvatar   = writerUser.avatarUrl || null;      

          window.allFetchedPosts.push(post);

          // 해시태그 수집
          if(post.content) {
              post.content.forEach(c => {
                  if(c.text) {
                       const tags = c.text.match(/#[^\s#]+/g);
                       if(tags) tags.forEach(t => window.globalHashtags.add(t.substring(1))); 
                  }
              });
          }
      });

      // 화면 렌더링
      if (typeof window.renderMonthlyBest === 'function') {
        window.renderMonthlyBest(window.allFetchedPosts); // ★ 추가
      }
      if (typeof window.renderBestInterior === 'function') {
        window.renderBestInterior(window.allFetchedPosts);
      }
      if (typeof window.renderPopularProducts === 'function') {
        window.renderPopularProducts(window.allFetchedPosts);
      }
      if (typeof window.renderDailyThemeSection === 'function') {
        window.renderDailyThemeSection(window.allFetchedPosts);
      }

      window.allPosts = [...window.allFetchedPosts];
      applyFilters(); 
      if (typeof window.triggerScrollReveal === 'function') window.triggerScrollReveal(); 

      hideLoader();

  } catch(e) {
      console.error("LoadGallery Fatal Error:", e);
  } finally {
      window.isGalleryLoading = false;
  }
}

async function loadSinglePost(postId) {
  document.getElementById('filterBar').classList.add('hidden');
  
  // 내 팔로우 목록 확보 (기존 유지)
  if (currentUserId && currentUserId !== 'Guest' && (!window.currentUserFollowing || window.currentUserFollowing.length === 0)) {
      try {
          const mySnap = await getDoc(doc(db, "users", String(currentUserId)));
          if (mySnap.exists()) {
              const rawData = mySnap.data().following || [];
              window.currentUserFollowing = rawData.map(id => String(id));
          }
      } catch (e) { console.warn("내 팔로우 정보 로드 실패", e); }
  }

  try {
      const docRef = doc(db, "posts", postId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
          const d = { id: docSnap.id, ...docSnap.data() };
          window[`post_data_${d.id}`] = d;
          window.currentPostData = d; 
          
          // ▼▼▼ [핵심 수정] 작성자의 최신 닉네임을 DB에서 가져오기 ▼▼▼
          let displayName = d.user || "User";
          if (d.userId) {
              try {
                  const userSnap = await getDoc(doc(db, "users", String(d.userId)));
                  if (userSnap.exists()) {
                      const uData = userSnap.data();
                      // 닉네임이 있으면 닉네임, 없으면 본명 적용
                      displayName = uData.nickname || uData.name || d.user;
                  }
              } catch (err) { console.warn("유저 정보 로드 실패", err); }
          }
          
          // 탭 타이틀에 최신 닉네임 적용!
          document.title = `${displayName}さんの暮らし | Community`;
          // ▲▲▲ [여기까지] ▲▲▲
          
          showDetail(d, false);
      } else {
          alert("削除された投稿です。");
          location.href = window.location.pathname; 
      }
  } catch(e) { 
      console.error("게시글 로드 에러:", e);
      location.href = window.location.pathname; 
  } finally { hideLoader(); }
}

// 유저 프로필 로드 (팔로우 목록 동기화 추가)
async function loadUserProfile(targetUserId) {
    const gridContainer = document.getElementById('gridContainer');
    const filterBar = document.getElementById('filterBar');
    const profileView = document.getElementById('userProfileView');

    // ▼▼▼▼ [새로 추가] 프로필 열 때 검색창 래퍼 찾아서 숨기기 ▼▼▼▼
    const searchWrap = document.querySelector('.fh-search-wrapper');
    if (searchWrap) searchWrap.style.display = 'none';
    // ▲▲▲▲ [여기까지 추가] ▲▲▲▲

    // ▼▼▼▼ [새로 추가] 프로필 진입 시 상단 타이틀/배너 싹 날리기 ▼▼▼▼
    const presentBar = document.querySelector('.fh-present-bar');
    const titleWrap = document.querySelector('.fh-title-wrapper');
    const mainHeader = document.getElementById('mainHeader');
    
    if(presentBar) presentBar.style.display = 'none';
    if(titleWrap) titleWrap.style.display = 'none';
    if(mainHeader) mainHeader.style.display = 'none';

    // 프로필 화면에서는 우측 '점 3개(편집/삭제)' 버튼이 필요 없으므로 숨김
    const mobileMenuBtn = document.getElementById('mobileHeaderMenuBtn');
    if (mobileMenuBtn) {
        mobileMenuBtn.style.visibility = 'hidden'; 
        mobileMenuBtn.onclick = null;
    }
    // ▲▲▲▲ [여기까지 추가] ▲▲▲▲

    // 1. 프로필 페이지에서는 메인 섹션들 숨기기
    const bestSec = document.getElementById('bestInteriorSection');
    const popSec = document.getElementById('popularProductsSection');
    const themeSec = document.getElementById('dailyThemeSection'); // 테마 섹션도 숨김
    if (bestSec) bestSec.classList.add('hidden');
    if (popSec) popSec.classList.add('hidden');
    if (themeSec) themeSec.classList.add('hidden');

    if (gridContainer) gridContainer.classList.add('hidden');
    if (filterBar) filterBar.classList.add('hidden');
    
    profileView.classList.remove('hidden');
    profileView.innerHTML = '<div class="fh-empty-msg" style="padding:100px 0;">Loading...</div>';

    // ★★★ [핵심 추가] 프로필 페이지에 들어올 때도 '내 팔로우 목록'을 최신화합니다. ★★★
    if (currentUserId && currentUserId !== 'Guest') {
        try {
            // 내 정보를 가져와서 window.currentUserFollowing에 저장
            const mySnap = await getDoc(doc(db, "users", String(currentUserId)));
            if (mySnap.exists()) {
                // ID를 확실하게 문자열로 변환하여 저장
                const rawData = mySnap.data().following || [];
                window.currentUserFollowing = rawData.map(id => String(id));
            } else {
                window.currentUserFollowing = [];
            }
        } catch (e) {
            console.error("Follow list sync error:", e);
        }
    }
    // ★★★ [추가 완료] ★★★

    try {
        // 1. 검색용 ID 준비 (문자형 vs 숫자형)
        const strId = String(targetUserId);
        const numId = Number(targetUserId);
        
        // 2. [핵심] 동시에 3가지를 조회합니다. (유저정보, 문자ID로 쓴 글, 숫자ID로 쓴 글)
        const [targetUserSnap, postsSnapStr, postsSnapNum] = await Promise.all([
            getDoc(doc(db, "users", strId)), // 유저 정보
            getDocs(query(collection(db, "posts"), where("userId", "==", strId), orderBy("date", "desc"))), // 문자 ID 검색
            getDocs(query(collection(db, "posts"), where("userId", "==", numId), orderBy("date", "desc")))  // 숫자 ID 검색
        ]);

        if (!targetUserSnap.exists()) {
            profileView.innerHTML = '<div class="fh-empty-msg">User not found.</div>';
            return;
        }

        // 3. 두 검색 결과(문자결과 + 숫자결과)를 합칩니다.
        // (중복된 글이 있을 리는 없지만, 안전하게 합쳐서 리스트로 만듭니다)
        let mergedDocs = [...postsSnapStr.docs, ...postsSnapNum.docs];
        
        // 4. 날짜순으로 다시 정렬 (합쳤으니까 뒤죽박죽일 수 있음)
        mergedDocs.sort((a, b) => {
            const dateA = new Date(a.data().date);
            const dateB = new Date(b.data().date);
            return dateB - dateA; // 최신순
        });

        // 5. 변수 연결
        const u = targetUserSnap.data();
        const posts = mergedDocs; // 이제 posts에는 찾아진 모든 글이 들어있습니다.
        const displayName = u.nickname || u.name || 'Unknown';

        document.title = `${displayName} | Community`;

        // ▼▼▼▼ [여기서부터 덮어씌워 주세요] ▼▼▼▼
        profileView.innerHTML = `
            <div class="fh-profile-mobile-header">
                <div class="fh-header-left" onclick="goToGallery()">
                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                </div>
                <div class="fh-header-center" style="font-weight:700; font-size:16px;">Profile</div>
                <div class="fh-header-right" onclick="goToGallery()">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                </div>
            </div>

            <div class="pp-container">
                <div class="pp-left">
                    <div class="pp-avatar" id="ppMainAvatar"></div>
                    <div class="pp-name" id="ppMainName" style="margin-bottom: 10px; display:flex; align-items:center; justify-content:center;"></div>
                    <div class="pp-bio" id="ppMainBio" style="margin-bottom: 20px;"></div>
                    
                    <div id="ppActionArea" style="width:100%; display:flex; flex-direction:column; gap:10px; align-items:center;"></div>
                    
                    <div class="pp-stats" style="display: grid; grid-template-columns: repeat(3, 1fr); width: 100%; align-items: flex-end; padding-top: 35px; position: relative;">
                        
                        <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                            <span class="pp-stat-num">${posts.length}</span>
                            <span class="pp-stat-label" style="margin: 0;">Posts</span>
                        </div>
                        
                        <div style="display: flex; flex-direction: column; align-items: center; gap: 4px; position: relative;">
                            <div style="position: absolute; bottom: 18px; left: 50%; transform: translateX(-50%); width: 90px; height: 54px; pointer-events: none; z-index: 1;">
                                <svg viewBox="0 0 200 120" style="width: 100%; height: 100%; overflow: visible;">
                                    <path d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="#f2f4f6" stroke-width="18" stroke-linecap="round"></path>
                                    <path id="ppProfileGauge" d="M 20 100 A 80 80 0 0 1 180 100" fill="none" stroke="#3182f6" stroke-width="18" stroke-linecap="round" stroke-dasharray="251.2" stroke-dashoffset="251.2" style="transition: stroke-dashoffset 1.5s cubic-bezier(0.22, 1, 0.36, 1);"></path>
                                </svg>
                            </div>
                            <div style="position: relative; z-index: 2; display: flex; align-items: baseline; justify-content: center;">
                                <span id="ppProfilePercent" class="pp-stat-num">0</span>
                                <span style="font-size: 12px; margin-left: 2px; color: #888; font-weight: 600;">%</span>
                            </div>
                            <span class="pp-stat-label" style="margin: 0; z-index: 2;">採択率</span>
                        </div>

                        <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                            <span class="pp-stat-num" id="ppFollowerCount">${u.followers ? u.followers.length : 0}</span>
                            <span class="pp-stat-label" style="margin: 0;">Followers</span>
                        </div>
                    </div>
                    <button onclick="goToGallery()" class="pp-back-btn">← Back to Community</button>
                </div>
                <div class="pp-right"><div class="pp-grid" id="ppGridBox"></div></div>
            </div>
        `;
        // ▲▲▲▲ [여기까지 덮어씌우기] ▲▲▲▲

        // ==============================================================
        // ★ [NEW] 프로필 조회 대상 유저의 QnA 채택률 계산 및 애니메이션 실행
        // ==============================================================
        setTimeout(async () => {
            try {
                // 해당 유저가 단 댓글만 싹 가져옵니다
                const qQuery = query(collection(db, "qna_comments"), where("userId", "==", String(targetUserId)));
                const qSnap = await getDocs(qQuery);

                let tCount = 0; // 총 답변 수
                let bCount = 0; // 채택된 수

                qSnap.forEach(doc => {
                    const d = doc.data();
                    if (d.parentId) return; // 대댓글은 실적에서 제외!
                    tCount++;
                    if (d.isBest) bCount++;
                });

                // 퍼센트 계산
                let pct = 0;
                if (tCount > 0) pct = Math.round((bCount / tCount) * 100);

                const pGauge = document.getElementById('ppProfileGauge');
                const pNum = document.getElementById('ppProfilePercent');

                if (pGauge && pNum) {
                    // 1. 게이지 차오르는 애니메이션
                    const maxDash = 251.2;
                    const offset = maxDash - (maxDash * (pct / 100));
                    setTimeout(() => { pGauge.style.strokeDashoffset = offset; }, 100);

                    // 2. 숫자 다다다닥 올라가는 애니메이션
                    let start = 0;
                    const duration = 1500;
                    const startTime = performance.now();

                    function animateNum(currentTime) {
                        const elapsed = currentTime - startTime;
                        const progress = Math.min(elapsed / duration, 1);
                        const ease = 1 - Math.pow(2, -10 * progress);
                        pNum.innerText = Math.floor(ease * pct);

                        if (progress < 1) requestAnimationFrame(animateNum);
                        else pNum.innerText = pct; // 최종 안착!
                    }
                    requestAnimationFrame(animateNum);
                }
            } catch (err) {
                console.error("프로필 채택률 로드 에러:", err);
            }
        }, 100); // HTML 렌더링 후 살짝 여유를 두고 실행
        
        document.getElementById('ppMainName').textContent = displayName;
        document.getElementById('ppMainBio').textContent = u.bio || 'No bio yet.';
        const avtEl = document.getElementById('ppMainAvatar');
        
        if (u.avatarUrl) {
            avtEl.style.backgroundImage = `url('${u.avatarUrl}')`;
            avtEl.textContent = "";
        } else {
            avtEl.textContent = displayName.charAt(0).toUpperCase();
        }

        const actionArea = document.getElementById('ppActionArea');

        // 인스타그램 버튼
        if (u.instagramId && u.instagramId.trim() !== "") {
            let instaUrl = u.instagramId.trim();
            if (!instaUrl.startsWith('http')) {
                instaUrl = 'https://instagram.com/' + instaUrl.replace('@', '');
            }
            const instaBtn = document.createElement('button');
            instaBtn.className = 'fh-btn-line pp-insta-btn'; // 기존 스타일 클래스 활용
            instaBtn.innerHTML = `
                <img src="https://cdn-icons-png.flaticon.com/512/174/174855.png" style="width:16px; height:16px;">
                Instagram
            `;
            instaBtn.onclick = () => window.open(instaUrl, '_blank');
            actionArea.appendChild(instaBtn);
        }

        // 팔로우 버튼
        if (currentUserId && String(currentUserId) !== String(targetUserId)) {
            // 위에서 최신화한 목록(window.currentUserFollowing)을 기준으로 판단
            const isFollowing = window.currentUserFollowing && window.currentUserFollowing.includes(String(targetUserId));
            
            const followBtn = document.createElement('button');
            followBtn.dataset.userId = String(targetUserId);
            followBtn.className = 'pp-btn-follow';
            
            // UI 상태 설정 (unfollow/follow 텍스트 및 색상)
            window.updateFollowButtonUI(followBtn, isFollowing);
            
            followBtn.onclick = function() { 
                window.toggleFollow(this, targetUserId); 
            };
            actionArea.appendChild(followBtn);
        }

        const gridBox = document.getElementById('ppGridBox');
        if (posts.length === 0) {
            gridBox.innerHTML = '<div class="fh-empty-msg" style="grid-column:1/-1;">No posts yet.</div>';
        } else {
            posts.forEach(postDoc => {
                const d = postDoc.data();
                if (d.isDeleted) return;

                const first = d.content[0];
                const item = document.createElement('div');
                item.className = 'pp-grid-item';
                item.onclick = () => location.href = `?post_id=${postDoc.id}`;
                item.innerHTML = first.type === 'video' 
                    ? `<video src="${first.url}" class="pp-grid-img" muted></video><div class="pp-video-mark">▶</div>` 
                    : `<img src="${first.url}" class="pp-grid-img">`;
                gridBox.appendChild(item);
            });
        }

    } catch (e) {
        console.error("Profile Load Error:", e);
        profileView.innerHTML = '<div class="fh-empty-msg">Error loading profile.</div>';
    } finally {
        hideLoader();
    }
}


// [수정 완료] 유저 프로필/마이페이지 게시글 로드 함수
window.loadUserPosts = async function(targetUserId) {
    const grid = document.getElementById('userPostGrid'); // 마이페이지의 그리드 ID 확인 필요
    if (!grid) return;
    grid.innerHTML = "";

    // [로딩 표시]
    grid.innerHTML = '<div class="fh-loader" style="grid-column:1/-1; text-align:center;">Loading...</div>';

    try {
        // ★ [핵심 수정] 여기서 String()을 안 씌우면 게시글이 0개로 나옵니다!
        const q = query(collection(db, "posts"), 
            where("userId", "==", String(targetUserId)), 
            orderBy("date", "desc")
        );
        
        const snap = await getDocs(q);

        if (snap.empty) {
            grid.innerHTML = '<div style="grid-column:1/-1; text-align:center; padding:40px; color:#999;">投稿がまだありません (No posts yet)</div>';
            return;
        }

        grid.innerHTML = ""; // 로딩 지우기

        snap.forEach(doc => {
            const d = doc.data();
            const el = document.createElement('div');
            el.className = 'fh-grid-item'; // 기존 그리드 아이템 클래스
            el.onclick = () => window.loadSinglePost(doc.id); // 클릭 시 상세페이지 이동
            
            // 썸네일 이미지 찾기 (비디오면 썸네일, 이미지면 첫번째 장)
            let thumb = "";
            if (d.content && d.content.length > 0) {
                // 비디오 썸네일 혹은 이미지 URL
                thumb = d.content[0].thumbnail || d.content[0].url || d.content[0].image;
            }

            // 핀 개수 아이콘 (선택 사항)
            const pinCount = (d.content || []).reduce((acc, cur) => acc + (cur.hotspots ? cur.hotspots.length : 0), 0);
            const pinBadge = pinCount > 0 ? `<div class="fh-pin-badge">📍${pinCount}</div>` : '';

            el.innerHTML = `
                <div class="fh-img-box" style="background-image: url('${thumb}');">
                    ${pinBadge}
                </div>
            `;
            grid.appendChild(el);
        });

    } catch (e) {
        console.error("User posts load error:", e);
        // 인덱스 에러일 경우 콘솔에 링크가 뜹니다. 그 링크를 클릭해서 인덱스를 만들어줘야 합니다.
    }
};

// [수정] 추천 게시글 로드 (삭제된 글 필터링 추가)
window.loadRecommendedPosts = async function(currentPostId) {
  const grid = document.getElementById('recGrid');
  if(!grid) return;
   
  grid.innerHTML = ""; // 초기화

  // 1. 데이터 확보
  let posts = window.allFetchedPosts || [];
    
  // 데이터가 없으면(직접 접속 등) 새로 가져옴
  if(posts.length === 0) {
      try {
          const q = query(collection(db, "posts"), orderBy("date", "desc"), limit(50));
          const snap = await getDocs(q);
          posts = [];
          snap.forEach(d => posts.push({ id: d.id, ...d.data() }));
      } catch(e) {
          console.error("추천 게시글 로딩 실패:", e);
      }
  }

  // 2. [핵심] 필터링 (현재 글 제외 AND 삭제된 글 제외)
  let validPosts = posts.filter(p => {
      // (1) 현재 보고 있는 글이면 제외
      if (p.id === currentPostId) return false;
      // (2) 삭제된 글이면 제외 ('isDeleted'가 true인 것)
      if (p.isDeleted) return false;
      // (3) 내용(이미지)이 없으면 제외
      if (!p.content || p.content.length === 0) return false;
      
      return true;
  });

  // 3. 랜덤 섞기
  validPosts.sort(() => Math.random() - 0.5);

  // 4. 최대 12개 선택
  const selected = validPosts.slice(0, 12); 

  if(selected.length === 0) {
      grid.innerHTML = '<div style="grid-column:1/-1; text-align:center; padding:40px 0; color:#999; font-size:13px;">まだ他の投稿がありません。<br>(No other posts yet)</div>';
      return;
  }

  // 5. 렌더링
  selected.forEach(p => {
      const first = p.content[0];
      if (!first.url) return;

      const item = document.createElement('div');
      item.className = 'fh-rec-item';
      item.onclick = () => location.href = `?post_id=${p.id}`;

      let mediaHtml = (first.type === 'video')
          ? `<video src="${first.url}" class="fh-rec-img" muted></video><div class="pp-video-mark">▶</div>` 
          : `<img src="${first.url}" class="fh-rec-img" loading="lazy">`;

      item.innerHTML = mediaHtml;
      grid.appendChild(item);
  });
};

// [댓글 로드] 대댓글 카운트 포함 & 좋아요 버튼 추가 버전
window.loadComments = async function(postId) {
    const list = document.getElementById('commentList');
    if(!list) return;
    
    list.innerHTML = '<div style="padding:20px; text-align:center; color:#999; font-size:13px;">Loading...</div>';

    try {
        const postRef = doc(db, "posts", postId);
        const snap = await getDoc(postRef);
        
        if (!snap.exists()) return;
        
        const data = snap.data();
        const comments = data.comments || [];
        
        // ★ [1] 전체 댓글 수 계산 (메인 댓글 + 대댓글 모두 합산)
        let totalCount = comments.length;
        comments.forEach(c => { 
            if(c.replies) totalCount += c.replies.length; 
        });

        // 상단 타이틀 ("Comments 5") 업데이트
        const titleEl = document.querySelector('.fh-comment-title');
        if(titleEl) titleEl.innerHTML = `Comments <span>${totalCount}</span>`;

        // ★ [2] 우측 플로팅 버튼 숫자 업데이트
        const floatCountEl = document.getElementById('floatCommentCount');
        if(floatCountEl) floatCountEl.innerText = totalCount;

        list.innerHTML = ""; // 초기화

        if (comments.length === 0) {
            list.innerHTML = '<div style="padding:40px 0; text-align:center; color:#999; font-size:13px;">まだコメントがありません。<br>最初のコメントを残しましょう！</div>';
            return;
        }

        // ----------------------------------------------------
        // 댓글 렌더링 루프
        // ----------------------------------------------------
        // ----------------------------------------------------
        // 댓글 렌더링 루프 (community-script.js의 loadComments 내부)
        // ----------------------------------------------------
        comments.forEach((c, index) => {
            const item = document.createElement('div');
            item.className = 'fh-comment-item-wrap';
            item.style.marginBottom = "20px";

            let dateStr = formatDate(c.date);
            
            // 본인 확인
            const isOwner = (currentUserId && c.userId === currentUserId) || window.ShopifyInfo.isAdmin;
            
            // 삭제 버튼
            const deleteHtml = isOwner 
                ? `<span class="fh-meta-dot"></span><button onclick="deleteComment('${postId}', ${index})" class="fh-meta-btn fh-btn-delete">削除</button>` 
                : '';
            
            // 답글 버튼
            const replyBtnHtml = currentUserId 
                ? `<span class="fh-meta-dot"></span><button onclick="toggleReplyForm(${index})" class="fh-meta-btn">返信</button>` 
                : '';

            // ★ [메인 댓글] 좋아요 버튼 생성
            const likes = c.likes || [];
            const isLiked = currentUserId && likes.includes(currentUserId);
            const likeCount = likes.length > 0 ? likes.length : 'いいね'; 
            
            const likeBtnHtml = `
                <button onclick="toggleCommentLike('${postId}', ${index}, null)" class="fh-meta-btn fh-like-btn ${isLiked ? 'active' : ''}">
                   <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                   <span>${likeCount}</span>
                </button>
            `;

            const avatarHtml = c.avatarUrl ? `<img src="${c.avatarUrl}">` : (c.user ? c.user.charAt(0) : '?');

            // ★ [핵심 1] 닉네임과 아바타 덮어쓰기를 위해 id 속성 부여 (cmt_avt_인덱스, cmt_name_인덱스)
            let mainCommentHtml = `
                <div class="fh-comment-item">
                    <div class="fh-comment-avatar" id="cmt_avt_${index}">${avatarHtml}</div>
                    <div class="fh-comment-body">
                        <div class="fh-comment-user" id="cmt_name_${index}">${c.user || 'Guest'}</div>
                        <div class="fh-comment-text">${c.text}</div>
                        <div class="fh-comment-meta">
                            <span>${dateStr}</span>
                            <span class="fh-meta-dot"></span>
                            ${likeBtnHtml}
                            ${replyBtnHtml}
                            ${deleteHtml}
                        </div>
                    </div>
                </div>
            `;

            // ----------------------------------------------------
            // 대댓글(Replies) 렌더링
            // ----------------------------------------------------
            let repliesHtml = "";
            if (c.replies && c.replies.length > 0) {
                repliesHtml += `<div class="fh-reply-list">`;
                c.replies.forEach((r, rIndex) => {
                    const rDate = formatDate(r.date);
                    const rIsOwner = (currentUserId && r.userId === currentUserId) || window.ShopifyInfo.isAdmin;
                    
                    const rDeleteHtml = rIsOwner 
                        ? `<span class="fh-meta-dot"></span><button onclick="deleteReply('${postId}', ${index}, ${rIndex})" class="fh-meta-btn fh-btn-delete">削除</button>` 
                        : '';
                    
                    const rLikes = r.likes || [];
                    const rIsLiked = currentUserId && rLikes.includes(currentUserId);
                    const rLikeCount = rLikes.length > 0 ? rLikes.length : 'いいね';

                    const rLikeBtnHtml = `
                        <button onclick="toggleCommentLike('${postId}', ${index}, ${rIndex})" class="fh-meta-btn fh-like-btn ${rIsLiked ? 'active' : ''}">
                            <svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                            <span>${rLikeCount}</span>
                        </button>
                    `;

                    const rAvatar = r.avatarUrl ? `<img src="${r.avatarUrl}">` : (r.user ? r.user.charAt(0) : '?');

                    // ★ [핵심 2] 대댓글도 덮어쓰기를 위해 id 부여 (reply_avt_부모_자식, reply_name_부모_자식)
                    repliesHtml += `
                        <div class="fh-reply-item">
                            <div class="fh-reply-icon">↳</div>
                            <div class="fh-comment-avatar" id="reply_avt_${index}_${rIndex}" style="width:30px; height:30px; font-size:14px;">${rAvatar}</div>
                            <div class="fh-comment-body">
                                <div class="fh-comment-user" id="reply_name_${index}_${rIndex}" style="font-size:13px;">${r.user}</div>
                                <div class="fh-comment-text" style="font-size:14px;">${r.text}</div>
                                <div class="fh-comment-meta">
                                    <span>${rDate}</span>
                                    <span class="fh-meta-dot"></span>
                                    ${rLikeBtnHtml}
                                    ${rDeleteHtml}
                                </div>
                            </div>
                        </div>
                    `;
                });
                repliesHtml += `</div>`;
            }

            // 답글 작성 폼 (숨김 상태)
            const replyFormHtml = `
                <div id="replyForm_${index}" class="fh-reply-form">
                    <textarea id="replyInput_${index}" class="fh-reply-input" placeholder="返信を入力..."></textarea>
                    <div style="text-align:right; margin-top:5px;">
                        <button onclick="toggleReplyForm(${index})" class="fh-btn-text" style="font-size:12px;">キャンセル</button>
                        <button onclick="submitReply('${postId}', ${index})" class="fh-comment-submit">返信する</button>
                    </div>
                </div>
            `;

            item.innerHTML = mainCommentHtml + repliesHtml + replyFormHtml;
            list.appendChild(item);

            // ★★★ [가장 중요한 마법] HTML을 화면에 붙인 직후에 닉네임과 사진을 동기화합니다! ★★★
            if (c.userId) {
                updateUserProfileUI(c.userId, document.getElementById(`cmt_avt_${index}`), document.getElementById(`cmt_name_${index}`));
            }
            if (c.replies && c.replies.length > 0) {
                c.replies.forEach((r, rIndex) => {
                    if (r.userId) {
                        updateUserProfileUI(r.userId, document.getElementById(`reply_avt_${index}_${rIndex}`), document.getElementById(`reply_name_${index}_${rIndex}`));
                    }
                });
            }
        });

    } catch(e) {
        console.error(e);
    }
};

// [Lazy Load] 에디터 열 때만 실행됨 (특정 문구 포함된 상품 제외)
window.loadAllProducts = async function() {
  let page = 1;
  const limit = 250; 
  const rootUrl = window.ShopifyInfo.rootUrl || '/'; 
  console.log(`📦 제품 데이터 수집 시작...`);

  while(true) {
    try {
      const fetchUrl = `${rootUrl}products.json?limit=${limit}&page=${page}`;
      const res = await fetch(fetchUrl);
      if (!res.ok) break;

      const data = await res.json();
      let products = data.products;

      if (!products || products.length === 0) break;

      // ★ [추가된 부분] "ガラスページ" 문구가 제목에 있으면 목록에서 제외
      products = products.filter(p => !p.title.includes("ガラスページ"));

      const mapped = products.map(p => ({
        id: p.id,
        title: p.title,
        handle: p.handle,
        image: p.images.length > 0 ? p.images[0].src : '', 
        url: `${rootUrl}products/${p.handle}`.replace('//', '/'),
        price: p.variants && p.variants.length > 0 ? p.variants[0].price : 0
      }));

      window.fhProducts = window.fhProducts.concat(mapped);
      page++; 
      if(page > 20) break; 

    } catch (e) {
      console.error("Load Error:", e);
      break;
    }
  }
  console.log(`🎉 총 ${window.fhProducts.length}개의 제품 로딩 완료! (제외됨: ガラスページ)`);
}

window.openPostDetail = async function(postId) {
  showTopProgressBar(true); 
  try {
      const docRef = doc(db, "posts", postId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
          const postData = { id: docSnap.id, ...docSnap.data() };
          window[`post_data_${postId}`] = postData;

          const newUrl = window.location.pathname + '?post_id=' + postId;
          window.history.pushState({ path: newUrl }, '', newUrl);

          // 1. 화면에 내용 그리기
          showDetail(postData); 
      }
  } catch (e) {
      console.error("Preloading Error:", e);
  } finally {
      showTopProgressBar(false); 
  }
};


/* ==========================================================================
   SECTION 4. UI RENDERING (VIEW)
   - 가져온 데이터를 HTML로 그려주는 함수들
   ========================================================================== */
// 전역 변수로 현재 페이지 관리
window.currentRenderPage = 0;
const POSTS_PER_PAGE = 6; // ★ 한 번에 그릴 개수 (6개가 모바일에서 제일 부드럽습니다)

// 메인그리드 (무한 스크롤 적용 버전)
window.renderGalleryGrid = async function(posts, isAppend = false) {
  const container = document.getElementById('gridContainer');
  
  let activePosts = posts.filter(p => !p.isDeleted);
  if(activePosts.length === 0) { 
      container.innerHTML = '<div class="fh-empty-msg" style="padding:50px 0;">No posts match.</div>'; 
      return; 
  }

  // 처음 그릴 때(필터링, 새로고침 등)는 화면을 싹 비우고 0페이지부터 시작!
  if (!isAppend) {
      container.innerHTML = "";
      window.currentRenderPage = 0; 
      const gridDiv = document.createElement('div');
      gridDiv.className = 'fh-grid';
      gridDiv.id = 'mainGridDiv'; // 밑에 이어 붙이기 위해 ID 부여
      container.appendChild(gridDiv);
  }

  const gridDiv = document.getElementById('mainGridDiv');

  // ★ 12개씩 잘라서 가져오기
  const startIndex = window.currentRenderPage * POSTS_PER_PAGE;
  const endIndex = startIndex + POSTS_PER_PAGE;
  const postsToRender = activePosts.slice(startIndex, endIndex);
   
  postsToRender.forEach((d) => {
      if (!d.content || d.content.length === 0) return;

      const first = d.content[0];
      const isMulti = d.content.length > 1;
      const multiIconHtml = isMulti ? `<div class="fh-multi-icon"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg></div>` : '';
      const pinIconHtml = d.isPinned ? `<div style="position:absolute; top:12px; left:12px; z-index:20; background:rgba(0,0,0,0.6); color:#fff; width:30px; height:30px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:16px; backdrop-filter: blur(2px);">📌</div>` : '';
      const mediaHtml = first.type === 'video' ? `<video src="${first.url}" class="fh-card-video" muted loop playsinline></video>` : `<img src="${first.url}" class="fh-card-img" loading="lazy">`;

      const div = document.createElement('div');
      div.className = 'fh-feed-card';

      const likeCount = d.likes ? d.likes.length : 0;
      const scrapCount = d.scraps ? d.scraps.length : 0;
      
      let commentCount = 0;
      if(d.comments) {
          commentCount = d.comments.length;
          d.comments.forEach(c => { if(c.replies) commentCount += c.replies.length; });
      }

      const isLiked = d.likes && d.likes.some(l => (typeof l === 'string' ? l : l.uid) === window.currentUserId);
      const isScrapped = d.scraps && d.scraps.includes(window.currentUserId);

      // 이미 캐싱된 프로필 정보 사용 (DB 조회 안 함)
      const finalName = d.authorNickname || d.user || "User";
      const finalBio = (d.authorProfile && d.authorProfile.bio) ? d.authorProfile.bio : "";
      const photoUrl = d.authorAvatar;

      let avatarStyle = "";
      let avatarText = "";
      
      if (photoUrl) {
          avatarStyle = `background-image: url('${photoUrl}'); background-size: cover; background-position: center; border: 1px solid #eee;`;
      } else {
          avatarText = finalName.charAt(0).toUpperCase();
      }

      div.innerHTML = `
          <div class="fh-card-header">
            <div class="fh-user-info" onclick="location.href='?profile_id=${maskId(d.userId)}'">
                <div class="fh-avatar" style="${avatarStyle}">${avatarText}</div>
                <div class="fh-user-text-wrap">
                    <div class="fh-username">${finalName}</div>
                    <div class="fh-user-sub">${finalBio}</div>
                </div>
            </div>
            <div id="follow_btn_area_${d.id}"></div>
          </div>
          
          <div class="fh-card-title-top" onclick="openPostDetail('${d.id}')">${d.title}</div>
          <div class="fh-card-media-wrap" onclick="openPostDetail('${d.id}')">
              ${multiIconHtml} ${pinIconHtml} ${mediaHtml}
          </div>

          <div class="fh-card-actions">
             <div class="fh-action-left">
                 <button class="fh-icon-btn ${isLiked ? 'active' : ''}" onclick="handleLike(this, '${d.id}')">
                    ${getIcon('heart')}
                    <span class="fh-btn-count" data-count="${likeCount}">${formatCount(likeCount)}</span>
                 </button>
                 <button class="fh-icon-btn" onclick="location.href='?post_id=${d.id}'">
                    ${getIcon('comment')}
                    <span class="fh-btn-count">${formatCount(commentCount)}</span>
                 </button>
             </div>
             <div class="fh-action-right">
                 <button class="fh-icon-btn ${isScrapped ? 'saved' : ''}" onclick="handleScrap(this, '${d.id}')">
                    <span class="fh-btn-count" data-count="${scrapCount}">${formatCount(scrapCount)}</span>
                    ${getIcon('bookmark')}
                 </button>
             </div>
          </div>

          <div class="fh-card-content">
              <div class="fh-date">${d.date ? d.date.split('T')[0] : ''}</div>
          </div>
      `;
      
      const btnArea = div.querySelector(`#follow_btn_area_${d.id}`);
      const isMe = (String(d.userId) === String(window.currentUserId));
      if (!isMe && window.currentUserId && window.currentUserId !== 'Guest') {
           const isFollowing = window.currentUserFollowing && window.currentUserFollowing.includes(String(d.userId));
           const followBtn = document.createElement('button');
           followBtn.dataset.userId = String(d.userId);
           followBtn.className = isFollowing ? 'fh-card-follow-btn following' : 'fh-card-follow-btn';
           window.updateFollowButtonUI(followBtn, isFollowing);
           followBtn.onclick = (e) => {
               e.stopPropagation();
               window.toggleFollow(followBtn, String(d.userId));
           };
           btnArea.appendChild(followBtn);
      }

      gridDiv.appendChild(div);
  });
   
  // ★ 기존에 있던 스크롤 감지 센서 지우기
  const oldTrigger = document.getElementById('scroll-trigger');
  if (oldTrigger) oldTrigger.remove();

  // ★ 아직 그릴 데이터가 남았다면 바닥에 스크롤 감지 센서 달아주기
  if (endIndex < activePosts.length) {
      const triggerDiv = document.createElement('div');
      triggerDiv.id = 'scroll-trigger';
      triggerDiv.style.height = '10px'; // 바닥에 안 보이는 투명한 선
      container.appendChild(triggerDiv);

      // 브라우저의 최신 기술 (IntersectionObserver) - 바닥 선이 화면에 보이면 작동!
      const observer = new IntersectionObserver((entries) => {
          if(entries[0].isIntersecting) {
              observer.disconnect(); // 한 번 작동하면 센서 끄고
              window.currentRenderPage++; // 페이지 1 올린 다음
              window.renderGalleryGrid(posts, true); // true를 줘서 밑에 이어서 그려라!
          }
      });
      observer.observe(triggerDiv);
  }
};

//댓글페이징
window.renderCommentPage = function(postId, page) {
  const list = document.getElementById('commentList');
  list.innerHTML = ""; 

  const start = (page - 1) * window.commentsPerPage;
  const end = start + window.commentsPerPage;
  const pageData = window.allCommentsCache.slice(start, end);

  pageData.forEach(c => {
      list.appendChild(renderCommentItem(postId, c));
  });

  renderPagination(postId, page);
};

//댓글 페이지네이션 버튼 생성
window.renderPagination = function(postId, currentPage) {
  const pagination = document.getElementById('commentPagination');
  pagination.innerHTML = "";

  const totalComments = window.allCommentsCache.length;
  const totalPages = Math.ceil(totalComments / window.commentsPerPage);

  if (totalPages <= 1) return;

  if(currentPage > 1) {
     const prevBtn = document.createElement('button');
     prevBtn.className = 'fh-page-btn';
     prevBtn.innerText = "<";
     prevBtn.onclick = () => renderCommentPage(postId, currentPage - 1);
     pagination.appendChild(prevBtn);
  }

  for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement('button');
      btn.className = `fh-page-btn ${i === currentPage ? 'active' : ''}`;
      btn.innerText = i;
      btn.onclick = () => renderCommentPage(postId, i);
      pagination.appendChild(btn);
  }

  if(currentPage < totalPages) {
     const nextBtn = document.createElement('button');
     nextBtn.className = 'fh-page-btn';
     nextBtn.innerText = ">";
     nextBtn.onclick = () => renderCommentPage(postId, currentPage + 1);
     pagination.appendChild(nextBtn);
  }
};

//게시글 상세페이지
window.showDetailWithData = (id) => { const d = window[`post_data_${id}`]; if(d) showDetail(d); }
window.showDetail = function(d) {
  // 1. 화면 전환
  document.getElementById('galleryView').classList.add('hidden');
  document.getElementById('editorView')?.classList.add('hidden');
  
  const detailView = document.getElementById('detailView');
  if(detailView) {
      detailView.classList.remove('hidden');
      detailView.style.display = 'block';
  }
  const sticky = document.getElementById('stickyActions');
  if(sticky) {
      sticky.classList.remove('hidden');
      sticky.style.display = 'block'; // ★ goToGallery에서 붙인 'none 스티커'를 여기서 떼어냅니다!
  }

  // ▼▼▼▼ [여기서부터 추가] 상세 페이지 진입 시 상단 타이틀/버튼 영역 숨기기 ▼▼▼▼
  const presentBar = document.querySelector('.fh-present-bar');
  const titleWrap = document.querySelector('.fh-title-wrapper');
  const mainHeader = document.getElementById('mainHeader');
  
  if(presentBar) presentBar.style.display = 'none';
  if(titleWrap) titleWrap.style.display = 'none';
  if(mainHeader) mainHeader.style.display = 'none';
  // ▲▲▲▲ [여기까지 추가] ▲▲▲▲

  window.scrollTo(0, 0);

  // 2. 메타 정보 설정
  window.currentPostId = d.id; 
  window.currentPostData = d;
  try { updateDoc(doc(db, "posts", d.id), { views: increment(1) }); } catch(e) {}

  // 날짜 및 카운트 포맷팅
  let dateStr = "";
  try {
      const dateObj = new Date(d.date);
      dateStr = `${dateObj.getFullYear()}.${String(dateObj.getMonth() + 1).padStart(2, '0')}.${String(dateObj.getDate()).padStart(2, '0')}`;
  } catch(e) {}
  
  const fmt = (n) => n ? n.toLocaleString() : "0";
  
  // 1. 좋아요 개수
  const likeCount = d.likes ? d.likes.length : 0;
  
  // 2. ★ [수정됨] 저장(스크랩) 개수: bookmarks -> scraps 로 변경해야 함!
  const scrapCount = d.scraps ? d.scraps.length : 0;
  
  // 3. 메타 정보 주입
  const metaEl = document.getElementById('dtMetaInfo');
  if(metaEl) {
      // 기존: fmt(d.bookmarks?.length) -> 수정: fmt(scrapCount)
      metaEl.innerHTML = `<span>${dateStr}</span><span>いいね ${fmt(likeCount)}</span><span>保存 ${fmt(scrapCount)}</span><span>閲覧数 ${fmt(d.views + 1)}</span>`;
  }
  const titleEl = document.getElementById('dtTitle');
  if(titleEl) titleEl.textContent = d.title;

  const menuArea = document.getElementById('postMenuArea');
  if (menuArea) {
      menuArea.innerHTML = ""; // 초기화

      // 권한 체크 (String 변환 필수)
      const loginUserId = window.ShopifyInfo?.currentUserId || currentUserId;
      const isAdmin = window.ShopifyInfo?.isAdmin;
      const isOwner = loginUserId && String(loginUserId) === String(d.userId);

      if (isOwner || isAdmin) {
          const isPinned = d.isPinned === true;
          const pinLabel = isPinned ? "固定解除" : "固定する";
          // 관리자만 핀(고정) 기능 사용
          const pinBtnHtml = isAdmin ? `<button class="fh-menu-action" onclick="togglePin('${d.id}', ${isPinned})">${isPinned ? '📌 ' : '📍 '}${pinLabel}</button>` : '';

          menuArea.innerHTML = `
            <div class="fh-post-menu-wrap" style="position:relative;">
                <button class="fh-post-menu-btn" onclick="togglePostMenu()">•••</button>
                <div id="postMenuDropdown" class="fh-post-menu-dropdown hidden">
                    ${pinBtnHtml}
                    <button class="fh-menu-action" onclick="editPost('${d.id}')">編集</button>
                    <button class="fh-menu-action delete" onclick="deletePost('${d.id}')" style="color:#ed4956;">削除</button>
                </div>
            </div>`;
      }
  }

  // 9. 작성자 프로필 박스 및 팔로우 버튼 로직
  const authorActionArea = document.getElementById('authorActionArea');
  if (authorActionArea) {
      authorActionArea.innerHTML = "";
      const loginUserId = window.ShopifyInfo?.currentUserId || currentUserId;
      const targetUid = String(d.userId);
      const isMe = loginUserId && String(loginUserId) === targetUid;
      const isFollowing = window.currentUserFollowing && window.currentUserFollowing.includes(targetUid);

      if (isMe) {
          const myBtn = document.createElement('button');
          myBtn.className = 'fh-btn-line';
          myBtn.textContent = 'マイページ';
          myBtn.onclick = () => location.href = '/pages/community_mypage';
          authorActionArea.appendChild(myBtn);
      } else {
          const followBtn = document.createElement('button');
          followBtn.className = 'fh-btn-follow';
          followBtn.dataset.userId = targetUid; // ★ 연동 핵심
          // 초기 UI 상태 설정
          window.updateFollowButtonUI(followBtn, isFollowing);
          followBtn.onclick = () => window.toggleFollow(followBtn, targetUid);
          authorActionArea.appendChild(followBtn);
      }
  }

  // 작성자 정보 업데이트 (프로필 이미지, 이름 등)
  updateUserProfileUI(String(d.userId), 
      document.getElementById('dtAuthorAvatar'), 
      document.getElementById('dtAuthorName'), 
      document.getElementById('dtAuthorBio')
  );

  // 4. 콘텐츠 렌더링 (핀 연동 + 스크롤 복구)
  const box = document.getElementById('dtContent');
  if(box) {
      box.innerHTML = "";
      
      // 주거 정보 태그
      const sizeMap = { 'under6': '6畳以下', '6to8': '6~8畳', '8to10': '8~10畳', 'over10': '10畳以上' };
      const infoItems = [d.housing, d.structure, sizeMap[d.size] || d.size, d.family, d.region].filter(t => t && t !== 'all' && t !== 'Other');
      if(infoItems.length > 0) {
          const infoDiv = document.createElement('div');
          infoDiv.style.cssText = "color:#999; font-size:13px; margin-bottom:30px;";
          infoDiv.textContent = infoItems.join(' | ');
          box.appendChild(infoDiv);
      }

      if (d.content && Array.isArray(d.content)) {
          // 1. 로그인 여부 확인 (반복문 밖에서 한 번만 체크)
          const loginUserId = window.ShopifyInfo?.currentUserId || currentUserId;
          // 문자열 'Guest' 혹은 null/undefined일 경우 true (게스트)
          const isGuest = !loginUserId || loginUserId === 'Guest'; 

          d.content.forEach((b, bIdx) => { 
              // ★★★ [핵심 1] 게스트인데 두 번째 장(인덱스 1)부터다? -> 여기서 즉시 종료 (안 그림)
              if (isGuest && bIdx > 0) return; 

              // --- 여기서부터는 "로그인 유저" 또는 "게스트의 첫 번째 사진"만 실행됨 ---

              const group = document.createElement('div');
              group.className = 'fh-media-group';
              group.style.marginBottom = "60px";

              // 이미지 영역
              const frame = document.createElement('div');
              frame.className = "fh-image-container";
              frame.style.position = "relative"; 

              const src = b.url || b.image;
              if(src) {
                  if (b.type === 'video') {
                      frame.innerHTML = `<video src="${src}" controls autoplay muted playsinline loop style="width:100%; border-radius:8px;"></video>`;
                      frame.classList.add('loaded'); 
                  } else {
                      const img = document.createElement('img');
                      img.src = src;
                      img.style.width = "100%";
                      img.style.borderRadius = "8px";
                      img.onload = function() { frame.classList.add('loaded'); };
                      frame.appendChild(img);
                  }
              }

              // ★★★ [핵심 2] 게스트이고 첫 번째 사진(0번)이면 -> 오버레이(Login 버튼) 추가
              if (isGuest && bIdx === 0) {
                  const overlay = document.createElement('div');
                  overlay.className = 'fh-detail-guest-overlay';
                  overlay.innerHTML = `
                      <div class="fh-guest-content">
                          <p>ログインすると、インテリアの詳細情報や<br>タグ付けされたアイテム情報をご確認いただけます。</p>
                          <a href="${window.ShopifyInfo.loginUrl}" class="fh-guest-btn">Login</a>
                      </div>
                  `;
                  frame.appendChild(overlay);
                  // (주의: 여기서는 scroll 막는 코드 절대 넣지 마세요!)
              } 
              // 로그인 유저라면 핀(Hotspot) 그리기
              else if (!isGuest && b.hotspots && b.hotspots.length > 0) {
                  b.hotspots.forEach((h, idx) => {
                      const pin = document.createElement('div');
                      pin.className = `fh-hotspot-pin sync-pin-${d.id} fh-observe-pin`;
                      pin.dataset.syncUrl = h.url;
                      pin.style.left = h.x + "%";
                      pin.style.top = h.y + "%";
                      // 맨 앞에 0.8을 더해서 0.8초 동안 숨죽이고 있다가 나오도록 수정
                      pin.style.animationDelay = `${0.8 + (idx * 0.15) + (Math.random() * 0.1)}s`;
                      pin.onclick = () => window.open(h.url, '_blank');
                      pin.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>`;
                      
                      const tooltip = document.createElement('div');
                      tooltip.className = `fh-hotspot-tooltip sync-tooltip-${d.id}`;
                      tooltip.dataset.syncUrl = h.url;
                      tooltip.style.left = h.x + "%";
                      tooltip.style.top = h.y + "%";
                      tooltip.onclick = () => window.open(h.url, '_blank');
                      tooltip.innerHTML = `
                          <img src="${h.image}" class="fh-tooltip-img">
                          <div class="fh-tooltip-info">
                              <div class="fh-tooltip-title">${h.title}</div>
                              <div class="fh-tooltip-price">¥${Number(h.price).toLocaleString()}</div>
                          </div>
                          <div class="fh-tooltip-arrow">›</div>`;
                      
                      frame.appendChild(pin);
                      frame.appendChild(tooltip);

                      [pin, tooltip].forEach(el => {
                          el.onmouseenter = function() { handleSyncHover(d.id, h.url, true, 'pin', this); };
                          el.onmouseleave = function() { handleSyncHover(d.id, h.url, false, 'pin', this); };
                      });
                  });
              }
              group.appendChild(frame);

              // 하단 상품 썸네일 (게스트는 안 보임)
              if (!isGuest) {
                  const items = b.hotspots || b.products || b.pins || [];
                  if (items.length > 0) {
                      const scrollBox = document.createElement('div');
                      scrollBox.className = "fh-product-scroll-wrap";
                      scrollBox.addEventListener('wheel', (e) => { 
                          if (e.deltaY !== 0) { e.preventDefault(); scrollBox.scrollLeft += e.deltaY * 2; } 
                      }, { passive: false });

                      items.forEach(p => {
                          const info = p.productInfo || p;
                          const pUrl = info.url || info.link;
                          const pImg = info.image || info.img;

                          if (pUrl && pImg) {
                              const thumb = document.createElement('a');
                              thumb.href = pUrl;
                              thumb.target = "_blank";
                              thumb.className = `fh-prod-thumb-item sync-thumb-${d.id}`;
                              thumb.dataset.syncUrl = pUrl;
                              thumb.innerHTML = `<img src="${pImg}" class="fh-prod-thumb-img">`;
                              thumb.onmouseenter = function() { handleSyncHover(d.id, pUrl, true, 'thumb', this); };
                              thumb.onmouseleave = function() { handleSyncHover(d.id, pUrl, false, 'thumb', this); };
                              scrollBox.appendChild(thumb);
                          }
                      });
                      group.appendChild(scrollBox);
                  }
              }

              // --- E. 텍스트 (★수정됨: 게스트가 아니어야만 보임) ---
              if (!isGuest && b.text) { 
                  const txt = document.createElement('div');
                  txt.className = "fh-detail-text";
                  txt.style.marginTop = "15px";
                  txt.innerHTML = b.text.replace(/\n/g, '<br>');
                  group.appendChild(txt);
              }
              box.appendChild(group);
          });
      }
  }

  // 5. 하단 액션바 및 댓글 로드
  const likeBtn = document.getElementById('floatLikeBtn');
  if(likeBtn) {
      const isLiked = currentUserId && d.likes && d.likes.some(l => (String(l) === String(currentUserId) || l.uid === currentUserId));
      if(isLiked) likeBtn.classList.add('active'); else likeBtn.classList.remove('active');
      document.getElementById('floatLikeCount').innerText = d.likes ? d.likes.length : 0;
      likeBtn.onclick = () => handleLike(likeBtn, d.id);
  }
  loadComments(d.id);
  loadRecommendedPosts(d.id);


// ▼▼▼▼ [수정된 모바일 헤더 제어 로직] ▼▼▼▼
  const mobileMenuBtn = document.getElementById('mobileHeaderMenuBtn');
  if (mobileMenuBtn) {
      const isAdmin = window.ShopifyInfo?.isAdmin; // 관리자 여부
      const loginUserId = window.ShopifyInfo?.currentUserId || currentUserId;
      const isOwner = loginUserId && String(loginUserId) === String(d.userId);

      // 본인이거나 관리자이면 점 3개 노출
      if (isOwner || isAdmin) {
          mobileMenuBtn.style.visibility = 'visible';
          // ★ 클릭 시 드롭다운 대신 모바일 바텀시트 메뉴를 호출하도록 변경!
          mobileMenuBtn.onclick = function() { 
              window.showMobilePostMenu(d.id); 
          };
      } else {
          // 남의 글이면 숨김
          mobileMenuBtn.style.visibility = 'hidden';
          mobileMenuBtn.onclick = null;
      }
  }
  // ▲▲▲▲ [여기까지] ▲▲▲▲
  
  // ▼▼▼▼ [여기 붙여넣으세요] ▼▼▼▼
  const targetProfileUrl = `?profile_id=${maskId(d.userId)}`;
  const goToProfile = () => location.href = targetProfileUrl;

  const dtAvatar = document.getElementById('dtAuthorAvatar');
  const dtName = document.getElementById('dtAuthorName');

  if (dtAvatar) {
      dtAvatar.onclick = goToProfile;
      dtAvatar.style.cursor = 'pointer';
  }
  if (dtName) {
      dtName.onclick = goToProfile;
      dtName.style.cursor = 'pointer';
  }
  // ▲▲▲▲ [여기까지] ▲▲▲▲

  // [추가] 모바일 하단 액션바 렌더링 & 표시
  if (typeof renderMobileActionBar === 'function') {
      renderMobileActionBar(d);
  }
  const mobBar = document.getElementById('mobileStickyBar');
  if(mobBar) mobBar.classList.add('show');
  
  const fabBtn = document.getElementById('fabWriteBtn');
  if(fabBtn) fabBtn.classList.add('hide-fab');


  if (window.initPinObserver) initPinObserver();
};

// [수정 완료] 베스트 인테리어 (닉네임 & 프로필 사진 최신화 버전)
window.renderBestInterior = function(allPosts) {
    // 1. [데이터 필터링] 최근 30일 & 좋아요 순 TOP 10
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    let bestPosts = allPosts.filter(p => new Date(p.date) >= thirtyDaysAgo);
    
    // 좋아요 순 -> 최신순 정렬
    bestPosts.sort((a, b) => {
        const likesA = a.likes ? a.likes.length : 0;
        const likesB = b.likes ? b.likes.length : 0;
        if (likesA !== likesB) return likesB - likesA;
        return new Date(b.date) - new Date(a.date);
    });

    const top10 = bestPosts.slice(0, 10);

    // 데이터가 적으면 숨김 (3개 미만)
    if (top10.length < 3) {
        const section = document.getElementById('bestInteriorSection');
        if(section) section.style.display = 'none';
        return;
    }

    // 2. [HTML 생성]
    let section = document.getElementById('bestInteriorSection');
    if (!section) {
        section = document.createElement('div');
        section.id = 'bestInteriorSection';
        section.className = 'fh-best-section';
        const grid = document.getElementById('gridContainer');
        if(grid) grid.parentNode.insertBefore(section, grid);
    } else {
        section.style.display = 'block';
    }

    let cardsHtml = top10.map(d => {
        const first = d.content[0];
        const imgUrl = (first.type === 'video') ? (first.thumbnail || first.url) : first.url;
        
        let mediaTag = `<img src="${imgUrl}" class="fh-best-img" loading="lazy">`;
        if (first.type === 'video') {
             mediaTag = `<video src="${imgUrl}#t=0.1" class="fh-best-img" preload="metadata" muted></video>`;
        }

        const isScrapped = d.scraps && d.scraps.includes(currentUserId);
        const scrapClass = isScrapped ? 'saved' : '';

        // 1차: 게시글 당시 저장된 정보 사용
        let initialAvatar = '';
        if (d.authorAvatar) {
            initialAvatar = `background-image: url('${d.authorAvatar}');`;
        }
        const initialText = d.user ? d.user.charAt(0) : '?';

        return `
            <div class="fh-best-card" onclick="location.href='?post_id=${d.id}'">
                ${mediaTag}
                <div class="fh-best-overlay">
                    <div class="fh-best-info">
                        <div class="fh-best-avatar" id="bestAvt_${d.id}" style="${initialAvatar}">
                             ${initialAvatar ? '' : initialText}
                        </div>
                        <div class="fh-best-user" id="bestName_${d.id}">${d.user}</div>
                        
                        <button class="fh-best-scrap-btn ${scrapClass}" onclick="handleScrap(this, '${d.id}'); event.stopPropagation();">
                            ${getIcon('bookmark')}
                        </button>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    section.innerHTML = `
        <div class="fh-best-header">
            <div class="fh-best-title">🏆 Best Interior</div>
            <div class="fh-best-sub">人気のインテリアをチェックしましょう！</div>
        </div>
        <div class="fh-best-track" id="bestTrack">
            ${cardsHtml}
        </div>
    `;

    // 3. [최신 유저 정보 업데이트] (사진 + 닉네임)
    top10.forEach(d => {
        if (!d.userId) return;

        const userRef = doc(db, "users", String(d.userId));
        
        getDoc(userRef).then(snap => {
            if (snap.exists()) {
                const userData = snap.data();
                
                // (1) 아바타 업데이트
                const avatarEl = document.getElementById(`bestAvt_${d.id}`);
                if (avatarEl && userData.avatarUrl) {
                    avatarEl.style.backgroundImage = `url('${userData.avatarUrl}')`;
                    avatarEl.innerText = ""; 
                }

                // (2) ★ 닉네임 업데이트 (본명 -> 닉네임)
                const nameEl = document.getElementById(`bestName_${d.id}`);
                if (nameEl && userData.nickname) {
                    nameEl.innerText = userData.nickname;
                }
            }
        }).catch(err => {
            console.warn("Best user load error:", err);
        });
    });

    // 4. [자동 스크롤]
    startBestAutoScroll();
};

// 게시글의 겉(products)뿐만 아니라 속(content > hotspots)까지 다 뒤져서 찾아냅니다.
window.renderPopularProducts = function(posts) {
    const section = document.getElementById('popularProductsSection');
    const listContainer = document.getElementById('popProductList');
    if (!listContainer) return;

    listContainer.innerHTML = "";
    const productMap = new Map();

    console.log("PopularProducts: Scanning", posts.length, "posts for hotspots/products...");

    posts.forEach(post => {
        // 1. 게시글 최상위에 있는 상품 찾기 (기존 방식)
        let allItems = post.products || post.items || [];

        // 2. [핵심] 본문(content) 안쪽에 숨어있는 핀(hotspots) 찾기
        if (post.content && Array.isArray(post.content)) {
            post.content.forEach(media => {
                if (media.hotspots && Array.isArray(media.hotspots)) {
                    allItems = allItems.concat(media.hotspots);
                }
            });
        }

        // 3. 찾은 아이템 집계
        allItems.forEach(p => {
            const key = p.url || p.link || p.image; // 고유 키
            if (!key) return;

            // 데이터 정규화 (이름, 이미지, 가격 등)
            const cleanData = {
                title: p.title || p.name || 'Unknown Item',
                image: p.image || p.img,
                url: p.url || p.link
            };

            if (!productMap.has(key)) {
                productMap.set(key, { ...cleanData, count: 1 });
            } else {
                productMap.get(key).count += 1;
            }
        });
    });

    console.log("PopularProducts: Found", productMap.size, "unique items.");

    // 데이터 없으면 섹션 숨김
    if (productMap.size === 0) {
        if (section) section.style.display = 'none';
        return;
    } else {
        if (section) section.style.display = 'block';
    }

    // 상위 15개 정렬 및 렌더링
    const sortedProducts = [...productMap.values()]
        .sort((a, b) => b.count - a.count)
        .slice(0, 15);

    sortedProducts.forEach(prod => {
        const item = document.createElement('div');
        item.className = 'fh-pop-item';
        item.onclick = () => { if(prod.url) window.open(prod.url, '_blank'); };
        
        item.innerHTML = `
            <div class="fh-pop-img-box">
                <img src="${prod.image}" alt="${prod.title}" loading="lazy" onerror="this.style.display='none'">
            </div>
            <div class="fh-pop-name">${prod.title}</div>
        `;
        listContainer.appendChild(item);
    });
};

// [NEW] 데일리 랜덤 테마 섹션 렌더링
window.renderDailyThemeSection = function(allPosts) {
    const section = document.getElementById('dailyThemeSection');
    const grid = document.getElementById('themeGrid');
    const titleEl = document.getElementById('themeTitle');
    
    if (!section || !grid) return;

    // 1. 가능한 테마 목록 정의 (필터 키, 값, 일본어 표시명)
    const themes = [
        // 구조(Structure) 관련
        { type: 'structure', value: '1R', label: '1R' },
        { type: 'structure', value: '1K', label: '1K' },
        { type: 'structure', value: '1DK', label: '1DK' },
        { type: 'structure', value: '1LDK', label: '1LDK' },
        { type: 'structure', value: '2LDK', label: '2LDK' }
    ];

    // 2. 랜덤 테마 선택 및 필터링 시도
    // (게시글이 너무 적으면 다른 테마를 뽑도록 최대 5번 시도)
    let selectedPosts = [];
    let selectedTheme = null;
    let attempts = 0;

    while (selectedPosts.length < 2 && attempts < 5) { // 최소 2개 이상 게시글이 있는 테마 찾기
        const randomIndex = Math.floor(Math.random() * themes.length);
        selectedTheme = themes[randomIndex];

        selectedPosts = allPosts.filter(p => {
            // 삭제된 글 제외 + 이미지 있는 글만
            if (p.isDeleted || !p.content || p.content.length === 0) return false;
            
            // 조건 비교
            if (selectedTheme.type === 'structure') return p.structure === selectedTheme.value;
            if (selectedTheme.type === 'size') return p.size === selectedTheme.value;
            if (selectedTheme.type === 'family') return p.family === selectedTheme.value;
            return false;
        });
        
        attempts++;
    }

    // 3. 게시글이 너무 없으면 섹션 숨김
    if (selectedPosts.length === 0) {
        section.classList.add('hidden');
        return;
    }

    // 4. 섹션 표시 및 타이틀 설정
    section.classList.remove('hidden');
    
    // 멘트 생성 (예: "1LDKのお部屋、覗いてみませんか？")
    titleEl.innerHTML = `<span style="color:#000; font-weight:900;">${selectedTheme.label}</span> のお部屋、覗いてみませんか？`;
    
    // 5. 그리드 렌더링 (최대 8개만 표시)
    grid.innerHTML = "";
    // 랜덤 섞기 (매번 같은 순서면 재미없으니까)
    selectedPosts.sort(() => Math.random() - 0.5); 
    
    selectedPosts.slice(0, 8).forEach(post => {
        const first = post.content[0];
        const imgUrl = (first.type === 'video') ? (first.thumbnail || first.url) : first.url;
        const displayName = post.authorNickname || post.user || "Unknown";
        const el = document.createElement('div');
        el.className = 'fh-theme-card';
        el.onclick = () => window.openPostDetail(post.id); // 상세페이지 이동

        el.innerHTML = `
            <div class="fh-theme-img-wrap">
                ${first.type === 'video' 
                  ? `<video src="${imgUrl}#t=0.1" class="fh-theme-img" muted preload="metadata"></video>` 
                  : `<img src="${imgUrl}" class="fh-theme-img" loading="lazy">`
                }
            </div>
            <div class="fh-theme-info">
                <div class="fh-theme-user">${displayName}</div>
                <div class="fh-theme-desc">${post.title}</div>
            </div>
        `;
        grid.appendChild(el);
    });
};

//개별 댓글 html 생성
window.renderCommentItem = function(postId, c) {
    const div = document.createElement('div');
    div.className = 'fh-comment-item';
    
    const uniqueId = c.id; 
    const dateStr = c.date ? c.date.split('T')[0] : '';
    
    const likes = c.likes || [];
    const isLiked = likes.includes(currentUserId);
    const likeClass = isLiked ? 'liked' : '';
    const likeCount = likes.length > 0 ? likes.length : '';
    
    const replies = c.replies || [];
    let repliesHtml = '';
    
    if (replies.length > 0) {
        repliesHtml += `<div class="fh-reply-list">`;
        replies.forEach(r => {
            const rDate = r.date ? r.date.split('T')[0] : '';
            repliesHtml += `
                <div class="fh-reply-item">
                    <div class="fh-avatar" id="replyAvt_${r.id}" style="width:24px; height:24px; font-size:10px; margin-right:8px;">${r.user.charAt(0)}</div>
                    <div class="fh-comment-text-wrap">
                        <div class="fh-comment-user" id="replyName_${r.id}" style="font-weight:700; font-size:12px; cursor:pointer;" onclick="location.href='?profile_id=${r.userId}'">${r.user}</div>
                        <div class="fh-comment-text" style="font-size:12px;">${r.text}</div>
                        <div class="fh-comment-actions" style="font-size:10px;">
                            <span>${rDate}</span>
                        </div>
                    </div>
                </div>
            `;
        });
        repliesHtml += `</div>`;
    }

    div.innerHTML = `
      <div class="fh-comment-main" style="display:flex; gap:10px;">
          <div class="fh-avatar" id="cmtAvt_${uniqueId}" style="width:32px; height:32px; font-size:12px; flex-shrink:0;">${c.user.charAt(0)}</div>
          
          <div class="fh-comment-text-wrap" style="flex:1;">
              <div class="fh-comment-user" id="cmtName_${uniqueId}" style="font-weight:700; font-size:13px; cursor:pointer;" onclick="location.href='?profile_id=${c.userId}'">
                  ${c.user}
              </div>
              
              <div class="fh-comment-text" style="margin: 4px 0;">${c.text}</div>
              
              <div class="fh-comment-actions">
                  <span>${dateStr}</span>
                  <button class="fh-action-btn ${likeClass}" onclick="toggleCommentLike('${postId}', '${c.id}', this)">
                      ${getIcon('heart-small')} ${likeCount}
                  </button>
                  <button class="fh-action-btn" onclick="toggleReplyForm('${c.id}')">
                      ${getIcon('reply')} Reply
                  </button>
              </div>
          </div>
      </div>
      ${repliesHtml}
      <div id="replyForm_${c.id}" class="fh-reply-input-wrap">
          <input type="text" id="replyInput_${c.id}" class="fh-reply-input" placeholder="Add a reply...">
          <button class="fh-comment-submit" style="padding:0 10px; height:auto;" onclick="saveComment('${postId}', '${c.id}')">Send</button>
      </div>
    `;
    
    updateUserProfileUI(
        c.userId, 
        div.querySelector(`#cmtAvt_${uniqueId}`), 
        div.querySelector(`#cmtName_${uniqueId}`), 
        null
    );

    if (replies.length > 0) {
        replies.forEach(r => {
            updateUserProfileUI(
                r.userId,
                div.querySelector(`#replyAvt_${r.id}`),
                div.querySelector(`#replyName_${r.id}`),
                null
            );
        });
    }

    return div;
}

// [최종수정] 모바일 하단 액션바 렌더링 함수
window.renderMobileActionBar = function(d) {
    const bar = document.getElementById('mobileStickyBar');
    if (!bar) return;

    // 1. 현재 게시글 데이터 기반 상태 체크 (전역 변수 currentUserId 사용)
    const isLiked = d.likes && d.likes.some(l => (typeof l === 'string' ? l : l.uid) === currentUserId);
    const isScrapped = d.scraps && d.scraps.includes(currentUserId);

    const likeCount = d.likes ? d.likes.length : 0;
    const scrapCount = d.scraps ? d.scraps.length : 0;
    
    // 2. HTML 삽입 (onclick 함수명 확인: scrollToComments, sharePost)
    bar.innerHTML = `
        <div class="mob-action-item ${isLiked ? 'active-like' : ''}" onclick="handleLike(this, '${d.id}')">
            <div class="mob-action-icon" id="mobLikeIcon">
                <svg viewBox="0 0 24 24" fill="${isLiked ? '#ff3b30' : 'none'}" stroke="${isLiked ? '#ff3b30' : 'currentColor'}" stroke-width="2">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
            </div>
            <span id="mobLikeCount" style="font-size: 11px;">${window.formatCount(likeCount)}</span>
        </div>

        <div class="mob-action-item ${isScrapped ? 'active-scrap' : ''}" onclick="handleScrap(this, '${d.id}')">
            <div class="mob-action-icon" id="mobScrapIcon">
                <svg viewBox="0 0 24 24" fill="${isScrapped ? '#007aff' : 'none'}" stroke="${isScrapped ? '#007aff' : 'currentColor'}" stroke-width="2">
                    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                </svg>
            </div>
            <span id="mobScrapCount" style="font-size: 11px;">${window.formatCount(scrapCount)}</span>
        </div>

        <div class="mob-action-item" onclick="scrollToComments()">
            <div class="mob-action-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                   <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                </svg>
            </div>
            <span style="font-size: 11px;">コメント</span>
        </div>

        <div class="mob-action-item" onclick="shareCurrentPost()">
            <div class="mob-action-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="18" cy="5" r="3"></circle>
                    <circle cx="6" cy="12" r="3"></circle>
                    <circle cx="18" cy="19" r="3"></circle>
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
            </div>
            <span style="font-size: 11px;">共有</span>
        </div>
    `;
    
    // (선택사항) PC 화면상의 'active' 클래스 상태를 강제로 한 번 더 동기화
    setTimeout(() => {
        const pcLikeBtn = document.querySelector(`button[onclick*="handleLike"][onclick*="${d.id}"].active`);
        if(pcLikeBtn) {
            const iconWrap = document.getElementById('mobLikeIcon')?.parentNode;
            if(iconWrap) iconWrap.classList.add('active-like');
        }
    }, 100);
}

async function updateUserProfileUI(userId, avatarEl, nameEl = null, bioEl = null, instaBtn = null) {
  // 1. 유효성 검사 강화 (문자열 "undefined" 뿐만 아니라 실제 undefined 체크)
  if (!userId || String(userId) === "undefined" || userId === "Guest") return;

  try {
      // [핵심 수정] userId를 반드시 String()으로 감싸야 에러가 안 납니다!
      const userDoc = await getDoc(doc(db, "users", String(userId))); 
      
      if (userDoc.exists()) {
          const u = userDoc.data();
          const displayName = u.nickname || u.name || "Unknown";

          // 인증 뱃지 아이콘
          const badgeHtml = u.isVerified ? `
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left:4px; flex-shrink:0;">
                  <g>
                      <path fill="#000000" d="M22.5,12.5c0-1.58-0.875-2.95-2.148-3.6c0.154-0.435,0.238-0.905,0.238-1.4c0-2.21-1.71-3.998-3.818-3.998 c-0.47,0-0.92,0.084-1.336,0.25C14.818,2.415,13.51,1.5,12,1.5S9.184,2.417,8.563,3.75C8.148,3.585,7.697,3.5,7.227,3.5 c-2.11,0-3.818,1.79-3.818,4c0,0.495,0.083,0.965,0.238,1.4C2.375,9.55,1.5,10.92,1.5,12.5c0,1.435,0.716,2.69,1.77,3.46 c-0.128,0.45-0.2,0.93-0.2,1.415c0,2.21,1.71,4,3.818,4c0.47,0,0.92-0.086,1.336-0.252C8.865,22.5,10.171,23.417,11.682,23.417 S14.497,22.5,15.119,21.167c0.415,0.165,0.865,0.25,1.336,0.25c2.11,0,3.818-1.79,3.818-4c0-0.485-0.072-0.965-0.2-1.415 C21.175,15.22,22.5,13.935,22.5,12.5z"/>
                      <path fill="#FFFFFF" d="M10,17.4l-4.2-4.2l1.4-1.4l2.8,2.8l6.4-6.4l1.4,1.4L10,17.4z"/>
                  </g>
              </svg>` : '';

          if (nameEl) {
              nameEl.innerHTML = `${displayName}${badgeHtml}`;
              nameEl.style.display = "flex";
              nameEl.style.alignItems = "center";
          }

          if (avatarEl) {
              if (u.avatarUrl) {
                  avatarEl.style.backgroundImage = `url('${u.avatarUrl}')`;
                  avatarEl.style.backgroundSize = "cover";
                  avatarEl.innerText = "";
              } else {
                  avatarEl.style.backgroundImage = "none";
                  avatarEl.style.backgroundColor = "#eee";
                  // 닉네임이 없을 때 안전하게 처리
                  avatarEl.innerText = (displayName && displayName.length > 0) ? displayName.charAt(0).toUpperCase() : "?";
              }
          }
          
          if (bioEl) {
               const bioText = u.bio ? u.bio.replace(/\n/g, ' ') : ""; 
               bioEl.innerText = bioText;
          }

          if (instaBtn) {
              if (u.instagramId && u.instagramId.trim() !== "") {
                  let instaUrl = u.instagramId.trim();
                  if (!instaUrl.startsWith('http')) {
                      // @ 기호 제거 로직 추가
                      instaUrl = 'https://instagram.com/' + instaUrl.replace('@', '');
                  }
                  
                  // 버튼 HTML 생성
                  instaBtn.innerHTML = `
                      <button class="fh-btn-line pp-insta-btn" style="display:flex; align-items:center; gap:8px; cursor:pointer;">
                          <img src="https://cdn-icons-png.flaticon.com/512/174/174855.png" style="width:16px; height:16px;">
                          Instagram
                      </button>
                  `;
                  
                  // [수정] 버튼을 찾아서 클릭 이벤트를 거는 방식으로 변경 (더 안전함)
                  const actualBtn = instaBtn.querySelector('button');
                  if(actualBtn) {
                      actualBtn.onclick = (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          window.open(instaUrl, '_blank');
                      };
                  }
              } else {
                  instaBtn.innerHTML = "";
              }
          }
      }
  } catch (e) { 
      // 에러가 나도 전체 스크립트가 멈추지 않게 로그만 찍고 넘어갑니다.
      console.error("Profile Sync Error for ID:", userId, e); 
  }
}

// ==========================================
// ★ [최종 수정] 매월 1일 자동 갱신: 이달의 방 (Monthly Best) - 버그 픽스 완료
// ==========================================
window.renderMonthlyBest = function(allPosts) {
    const section = document.getElementById('monthlyBestSection');
    if (!section) return;

    const now = new Date();

    // ★ 오픈일 설정
    const openDate = new Date('2026-03-01T00:00:00+09:00');
    if (now < openDate) {
        section.style.display = 'none';
        return;
    }

    // 🚨 [수정 1] 날짜 계산 버그 픽스: 현재 달에서 무조건 -1을 해야 '지난달'이 됨
    let targetYear = now.getFullYear();
    let targetMonth = now.getMonth() - 1; // 여기서 1을 빼야 합니다!

    if (targetMonth < 0) { // 1월(0)에서 1을 빼서 -1이 되면 작년 12월로 변경
        targetMonth = 11;
        targetYear -= 1;
    }
    const prevMonthNumber = targetMonth + 1; 

    // 2. 지난달에 작성된 게시글만 필터링
    const prevMonthPosts = allPosts.filter(p => {
        if (p.isDeleted || !p.date) return false;
        const pDate = new Date(p.date);
        return pDate.getFullYear() === targetYear && pDate.getMonth() === targetMonth;
    });

    // 3. 좋아요 순으로 정렬
    prevMonthPosts.sort((a, b) => {
        const likesA = a.likes ? a.likes.length : 0;
        const likesB = b.likes ? b.likes.length : 0;
        if (likesA !== likesB) return likesB - likesA;
        return new Date(b.date) - new Date(a.date);
    });

    // 4. 상위 3개 자르기
    const top3 = prevMonthPosts.slice(0, 3);

    // 데이터가 하나도 없으면 숨김
    if (top3.length === 0) {
        section.style.display = 'none';
        return;
    }
    
    section.style.display = 'block';

    // 🚨 [수정 2] 시상대 배치 레이아웃 붕괴 방지: 게시글이 1~2개일 때도 3등분 비율 유지 (투명 더미 블록 사용)
    let podiumOrder = [];
    let originalRanks = [];

    if (top3.length === 3) {
        podiumOrder = [top3[1], top3[0], top3[2]];
        originalRanks = [2, 1, 3];
    } else if (top3.length === 2) {
        podiumOrder = [top3[1], top3[0], null]; // 3등 자리를 빈칸으로
        originalRanks = [2, 1, 0];
    } else if (top3.length === 1) {
        podiumOrder = [null, top3[0], null]; // 양옆을 빈칸으로 (가운데 1등만)
        originalRanks = [0, 1, 0];
    }

    // 6. HTML 생성
    let cardsHtml = podiumOrder.map((d, i) => {
        // 🚨 빈칸(null)인 경우 레이아웃 유지를 위해 투명한 빈 div 렌더링
        if (!d) return `<div style="visibility: hidden;"></div>`;

        const rank = originalRanks[i]; 
        const first = d.content[0];
        const imgUrl = (first.type === 'video') ? (first.thumbnail || first.url) : first.url;
        
        let rankClass;
        if (rank === 1) rankClass = 'rank-1'; // 금
        else if (rank === 2) rankClass = 'rank-2'; // 은
        else rankClass = 'rank-3'; // 동

        let mediaTag = `<img src="${imgUrl}" class="fh-monthly-img" loading="lazy">`;
        if (first.type === 'video') {
            mediaTag = `<video src="${imgUrl}#t=0.1" class="fh-monthly-img" preload="metadata" muted></video>`;
        }

        const displayName = d.authorNickname || d.user || "Unknown";
        
        const avatarUrl = d.authorAvatar;
        const initial = displayName.charAt(0).toUpperCase();
        let avatarHtml = `<div class="fh-monthly-avatar">${initial}</div>`;
        if (avatarUrl) {
            avatarHtml = `<div class="fh-monthly-avatar" style="background-image: url('${avatarUrl}');"></div>`;
        }

        return `
            <div class="fh-monthly-card ${rankClass}" onclick="location.href='?post_id=${d.id}'">
                <div class="fh-monthly-img-wrap">
                    ${mediaTag}
                </div>
                <div class="fh-monthly-info">
                    <div class="fh-monthly-user-wrap">
                        ${avatarHtml}
                        <div class="fh-monthly-user">${displayName}</div>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    section.innerHTML = `
        <div class="fh-monthly-header">
            <h2 class="fh-monthly-title">👑 ${prevMonthNumber}月の Best Room</h2>
            <p class="fh-monthly-sub">先月、最も愛されたトップ3のお部屋です。</p>
        </div>
        <div class="fh-monthly-grid-podium">
            ${cardsHtml}
        </div>
    `;
};

/* ==========================================================================
   SECTION 5. USER ACTIONS (WRITE/UPDATE)
   - 좋아요, 스크랩, 팔로우, 댓글 작성, 삭제 등 DB 변경 로직
   ========================================================================== */
// [수정됨] 좋아요 핸들러 (PC + 모바일 완벽 연동)
window.handleLike = async function(btn, postId) {
    // 1. 로그인 체크
    if (!currentUserId || currentUserId === 'Guest') {
        if(confirm("ログインが必要です。\nログインページに移動しますか？")) {
            location.href = window.ShopifyInfo.loginUrl + "?checkout_url=" + encodeURIComponent(window.location.pathname);
        }
        return;
    }

    // 2. 현재 상태 확인 (PC는 'active', 모바일은 'active-like' 클래스 사용)
    // ★ 수정됨: 버튼 종류에 따라 체크하는 클래스가 다름을 통합
    const isLiked = btn.classList.contains('active') || btn.classList.contains('active-like');
    
    // 3. [Optimistic UI] 화면 즉시 갱신
    
    // (A) 화면에 있는 '같은 ID'를 가진 모든 좋아요 버튼 찾기 (그리드, 리스트 등)
    const allLikeButtons = document.querySelectorAll(`button[onclick*="handleLike"][onclick*="${postId}"]`);
    
    allLikeButtons.forEach(b => {
        if (isLiked) b.classList.remove('active');
        else b.classList.add('active');

        const countSpan = b.querySelector('.fh-btn-count');
        if (countSpan) {
            let num = parseInt(countSpan.dataset.count) || 0;
            if (isLiked) num = Math.max(0, num - 1);
            else num++;
            countSpan.dataset.count = num;
            countSpan.innerText = window.formatCount(num);
        }
    });

    // (B) 상세 페이지 동기화
    if (window.currentPostId === postId) {
        // 1) PC용 플로팅 버튼 & 메타 정보
        const floatBtn = document.getElementById('floatLikeBtn');
        if (floatBtn) {
            if (isLiked) floatBtn.classList.remove('active'); 
            else floatBtn.classList.add('active');
        }

        const floatCount = document.getElementById('floatLikeCount');
        if (floatCount) {
            let current = parseInt(floatCount.innerText.replace(/[^0-9]/g, '')) || 0;
            const nextVal = isLiked ? Math.max(0, current - 1) : current + 1;
            floatCount.innerText = nextVal; 
        }

        const metaInfo = document.getElementById('dtMetaInfo');
        if (metaInfo) {
            metaInfo.innerHTML = metaInfo.innerHTML.replace(/Like\s*([0-9,]+)/, (match, p1) => { // 'Like' 텍스트에 맞춰 수정 필요 (현재 'いいね' 사용중이면 그에 맞게)
                // 만약 화면에 'いいね'로 되어있다면 위 정규식을 /いいね\s*([0-9,]+)/ 로 바꿔야 합니다.
                // 일단 안전하게 숫자만 증감시키는 로직은 유지합니다.
                let num = parseInt(p1.replace(/,/g, '')) || 0;
                let newNum = isLiked ? Math.max(0, num - 1) : num + 1;
                return `Like ${newNum.toLocaleString()}`; // 여기도 'いいね'로 통일 필요할 수 있음
            });
        }

        // 2) ★ [추가] 모바일 하단 액션바 동기화 (여기가 핵심!)
        const mobLikeIcon = document.getElementById('mobLikeIcon');
        const mobLikeCount = document.getElementById('mobLikeCount');
        
        if (mobLikeIcon && mobLikeCount) {
             if (isLiked) {
                 // 좋아요 취소 (빨강 제거)
                 mobLikeIcon.parentNode.classList.remove('active-like');
                 mobLikeIcon.querySelector('svg').setAttribute('fill', 'none');
                 
                 let num = parseInt(mobLikeCount.innerText) || 0;
                 mobLikeCount.innerText = Math.max(0, num - 1);
             } else {
                 // 좋아요 활성 (빨강 추가)
                 mobLikeIcon.parentNode.classList.add('active-like');
                 mobLikeIcon.querySelector('svg').setAttribute('fill', '#ff3b30');
                 
                 let num = parseInt(mobLikeCount.innerText) || 0;
                 mobLikeCount.innerText = num + 1;
             }
        }
    }

    // 4. 서버 전송 (Firebase)
    try {
        const postRef = doc(db, "posts", postId);
        if (isLiked) {
            // 취소
            const snap = await getDoc(postRef);
            if(snap.exists()) {
                const currentLikes = snap.data().likes || [];
                const newLikes = currentLikes.filter(l => {
                    const uid = (typeof l === 'string') ? l : l.uid;
                    return uid !== currentUserId;
                });
                await updateDoc(postRef, { likes: newLikes });
            }
        } else {
            // 추가
            const now = new Date().toISOString();
            await updateDoc(postRef, { 
                likes: arrayUnion({ uid: currentUserId, at: now }) 
            });
        }

        // 5. 로컬 데이터 업데이트
        if (window.allPosts) {
            const p = window.allPosts.find(item => item.id === postId);
            if (p) {
                if (!p.likes) p.likes = [];
                if (isLiked) {
                    p.likes = p.likes.filter(l => (typeof l === 'string' ? l : l.uid) !== currentUserId);
                } else {
                    p.likes.push({ uid: currentUserId });
                }
            }
        }

    } catch (e) {
        console.error("Like Error:", e);
    }
};

// [댓글/대댓글 좋아요] 토글 함수
window.toggleCommentLike = async function(postId, commentIndex, replyIndex) {
    if (!currentUserId || currentUserId === 'Guest') {
        alert("ログインが必要です。");
        return;
    }

    try {
        const postRef = doc(db, "posts", postId);
        const snap = await getDoc(postRef);
        if (!snap.exists()) return;

        // 데이터 가져오기 (배열 전체를 가져와서 수정 후 덮어쓰기)
        const data = snap.data();
        let comments = data.comments || [];

        // 타겟 찾기 (댓글 vs 대댓글)
        let targetObj = null;
        if (replyIndex === null) {
            // 메인 댓글
            targetObj = comments[commentIndex];
        } else {
            // 대댓글
            if(comments[commentIndex] && comments[commentIndex].replies) {
                targetObj = comments[commentIndex].replies[replyIndex];
            }
        }

        if (!targetObj) return;

        // likes 배열이 없으면 생성
        if (!targetObj.likes) targetObj.likes = [];

        // 내 ID가 있는지 확인
        const userIndex = targetObj.likes.indexOf(currentUserId);

        if (userIndex === -1) {
            // 없으면 -> 좋아요 추가
            targetObj.likes.push(currentUserId);
        } else {
            // 있으면 -> 좋아요 취소
            targetObj.likes.splice(userIndex, 1);
        }

        // Firestore 업데이트
        await updateDoc(postRef, { comments: comments });

        // 화면 갱신 (숫자 및 하트 색상 반영)
        loadComments(postId);

    } catch(e) {
        console.error("Comment Like Error:", e);
        alert("エラーが発生しました。");
    }
};

// [댓글] 엔터 키 입력 시 전송 (Shift+Enter는 줄바꿈)
window.handleCommentKey = function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault(); // 줄바꿈 방지
        // 현재 보고 있는 게시글 ID로 댓글 저장 함수 실행
        saveComment(window.currentPostId); 
    }
};

// [답글] 작성 폼 열기/닫기
window.toggleReplyForm = function(index) {
    const form = document.getElementById(`replyForm_${index}`);
    if (form) {
        if (form.style.display === 'block') {
            form.style.display = 'none';
        } else {
            form.style.display = 'block';
            document.getElementById(`replyInput_${index}`).focus();
        }
    }
};

// [수정] 스크랩 클릭 핸들러 (숫자 카운트 연동)
window.handleScrap = async function(btn, postId) {
  // 1. 로그인 체크
  if(!currentUserId || currentUserId === 'Guest') {
      if(confirm("ログインが必要です。\nログインページに移動しますか？")) {
          // goToLogin() 함수가 있다면 사용하시고, 없다면 아래처럼 직접 이동
          location.href = window.ShopifyInfo.loginUrl + "?checkout_url=" + encodeURIComponent(window.location.pathname);
      }
      return;
  }
   
  // 2. 현재 상태 확인 (PC는 'saved', 모바일은 'active-scrap' 클래스 사용 가능성)
  const isSaved = btn.classList.contains('saved') || btn.classList.contains('active-scrap');
  const postRef = doc(db, "posts", postId);

  // 3. [Optimistic UI] 화면 즉시 변경
  
  // (A) 화면에 있는 '같은 ID'를 가진 모든 스크랩 버튼 찾기 (그리드, 리스트 등)
  const allScrapBtns = document.querySelectorAll(`button[onclick*="handleScrap"][onclick*="${postId}"]`);
  
  allScrapBtns.forEach(b => {
      if(isSaved) b.classList.remove('saved');
      else b.classList.add('saved');

      const countSpan = b.querySelector('.fh-btn-count');
      if (countSpan) {
          let num = parseInt(countSpan.dataset.count) || 0;
          if (isSaved) num = Math.max(0, num - 1);
          else num++;
          
          countSpan.dataset.count = num;
          countSpan.innerText = formatCount(num); // formatCount 함수가 있다고 가정
      }
  });

  // (B) ★ [추가] 상세 페이지(Detail View) 모바일 바 & 메타 정보 동기화
  if (window.currentPostId === postId) {
      
      // 1) 상단 메타 정보 텍스트 (예: 保存 15) 업데이트
      const metaInfo = document.getElementById('dtMetaInfo');
      if (metaInfo) {
          // '保存' 텍스트 뒤의 숫자를 찾아서 변경
          metaInfo.innerHTML = metaInfo.innerHTML.replace(/保存\s*([0-9,]+)/, (match, p1) => {
              let num = parseInt(p1.replace(/,/g, '')) || 0;
              let newNum = isSaved ? Math.max(0, num - 1) : num + 1;
              return `保存 ${newNum.toLocaleString()}`;
          });
      }

      // 2) ★ [핵심] 모바일 하단 액션바 동기화
      const mobScrapIcon = document.getElementById('mobScrapIcon');
      const mobScrapCount = document.getElementById('mobScrapCount');
      
      if (mobScrapIcon && mobScrapCount) {
           if (isSaved) {
               // 스크랩 취소 (파란색 제거)
               mobScrapIcon.parentNode.classList.remove('active-scrap');
               mobScrapIcon.querySelector('svg').setAttribute('fill', 'none');
               
               let num = parseInt(mobScrapCount.innerText) || 0;
               mobScrapCount.innerText = Math.max(0, num - 1);
           } else {
               // 스크랩 활성 (파란색 추가)
               mobScrapIcon.parentNode.classList.add('active-scrap');
               mobScrapIcon.querySelector('svg').setAttribute('fill', '#007aff');
               
               let num = parseInt(mobScrapCount.innerText) || 0;
               mobScrapCount.innerText = num + 1;
           }
      }
  }

  // 4. 서버 전송 (Firebase)
  try {
      if(isSaved) {
          await updateDoc(postRef, { scraps: arrayRemove(currentUserId) });
      } else {
          await updateDoc(postRef, { scraps: arrayUnion(currentUserId) });
      }
      
      // 로컬 데이터 갱신
      if (window.allPosts) {
          const p = window.allPosts.find(item => item.id === postId);
          if (p) {
              if (!p.scraps) p.scraps = [];
              if (isSaved) p.scraps = p.scraps.filter(id => id !== currentUserId);
              else p.scraps.push(currentUserId);
          }
      }
  } catch(e) {
      console.error("Scrap Error:", e);
  }
};

// [FIX] 팔로우 토글 함수 (변수 선언 누락 수정됨)
window.toggleFollow = async function(btn, targetUid) {
    if (!currentUserId || currentUserId === 'Guest') {
        if(confirm("Login required. Go to login page?")) {
            location.href = window.ShopifyInfo?.loginUrl || '/account/login';
        }
        return;
    }

    const strCurrentId = String(currentUserId);
    const strTargetId = String(targetUid);
    
    // ★ [추가됨] 누락되었던 숫자형 ID 변수 정의
    const numCurrentId = Number(currentUserId);
    const numTargetId = Number(targetUid);

    if (strCurrentId === strTargetId) return; 

    if (!window.currentUserFollowing) window.currentUserFollowing = [];
    const isNowFollowing = window.currentUserFollowing.includes(strTargetId);
    
    const allRelatedBtns = document.querySelectorAll(`button[data-user-id="${strTargetId}"], button[data-userid="${strTargetId}"]`);
    const countEl = document.getElementById('ppFollowerCount');
    
    // UI 즉시 업데이트 (Optimistic UI)
    if (isNowFollowing) {
        // (A) Unfollow UI 처리
        window.currentUserFollowing = window.currentUserFollowing.filter(id => id !== strTargetId);
        
        allRelatedBtns.forEach(b => {
            b.classList.remove('following');
            b.innerText = "follow";
        });
        
        if (countEl) {
            let num = parseInt(countEl.innerText.replace(/,/g, '')) || 0;
            countEl.innerText = Math.max(0, num - 1).toLocaleString();
        }
    } else {
        // (B) Follow UI 처리
        if (window.triggerPopEffect) window.triggerPopEffect(window.event);
        window.currentUserFollowing.push(strTargetId);
        
        allRelatedBtns.forEach(b => {
            b.classList.add('following');
            b.innerText = "unfollow";
        });
        
        if (countEl) {
            let num = parseInt(countEl.innerText.replace(/,/g, '')) || 0;
            countEl.innerText = (num + 1).toLocaleString();
        }
    }

    // DB 업데이트
    try {
        const myRef = doc(db, "users", strCurrentId);
        const targetRef = doc(db, "users", strTargetId);

        if (isNowFollowing) {
            // 언팔로우: 문자ID와 숫자ID 모두 제거 시도 (안전장치)
            await updateDoc(myRef, { following: arrayRemove(strTargetId, numTargetId) });
            await updateDoc(targetRef, { followers: arrayRemove(strCurrentId, numCurrentId) });
        } else {
            // 팔로우: 문자ID로 추가
            await setDoc(myRef, { following: arrayUnion(strTargetId) }, { merge: true });
            await setDoc(targetRef, { followers: arrayUnion(strCurrentId) }, { merge: true });
        }
    } catch (e) {
        console.error("DB Error:", e);
        // 에러 발생 시 UI 롤백 (선택 사항)
        alert("DB ERROR");
        location.reload(); 
    }
};

//버튼 디자인 전담 함수 (Follow <-> Unfollow)
window.updateFollowButtonUI = function(btn, isFollowing) {
    if (!btn) return;
    if (isFollowing) {
        btn.classList.add('following');
        btn.innerText = "unfollow"; 
    } else {
        btn.classList.remove('following');
        btn.innerText = "follow"; 
    }
};

// [댓글 저장]
window.saveComment = async function(postId) {
    // 1. ID 안전장치: 인자로 안 넘어왔으면 전역 변수에서 찾기
    if (!postId) postId = window.currentPostId;
    if (!postId) return alert("Error: Post ID is missing. (画面を更新してください)");

    const input = document.getElementById('commentInput');
    const text = input.value.trim();
    if (!text) return; // 빈 댓글 방지

    // 2. 로그인 체크
    if (!currentUserId || currentUserId === 'Guest') {
         if(confirm("ログインが必要です。\nログインページに移動しますか？")) {
             location.href = window.ShopifyInfo.loginUrl + "?checkout_url=" + encodeURIComponent(window.location.pathname);
         }
         return;
    }

    // 3. 버튼 비활성화 (중복 전송 방지)
    const btn = document.getElementById('btnPostComment');
    btn.disabled = true;
    btn.innerText = "...";

    try {
        const commentData = {
            userId: currentUserId,
            user: window.ShopifyInfo.currentUser || "User", // 닉네임
            text: text,
            date: new Date().toISOString()
        };

        const postRef = doc(db, "posts", postId);

        // Firestore 배열에 추가 (arrayUnion 사용 안 함 - 객체라 비교 불가)
        // 기존 배열을 가져와서 push 하는 방식이 안전
        const snap = await getDoc(postRef);
        if (snap.exists()) {
            const data = snap.data();
            let comments = data.comments || [];
            comments.push(commentData);
            
            await updateDoc(postRef, { comments: comments });
        }

        // 입력창 초기화 및 목록 갱신
        input.value = "";
        loadComments(postId);
        
        // 상세페이지 댓글 카운트 업데이트
        const countEl = document.getElementById('floatCommentCount');
        if(countEl) {
            let num = parseInt(countEl.innerText) || 0;
            countEl.innerText = num + 1;
        }

    } catch (e) {
        console.error("Save Comment Error:", e);
        alert("Error saving comment: " + e.message);
    } finally {
        btn.disabled = false;
        btn.innerText = "投稿";
    }
};

// [답글] 서버 전송 (저장)
window.submitReply = async function(postId, parentIndex) {
    const input = document.getElementById(`replyInput_${parentIndex}`);
    const text = input.value.trim();
    if (!text) return;

    if (!currentUserId || currentUserId === 'Guest') {
        alert("ログインが必要です。");
        return;
    }

    try {
        const postRef = doc(db, "posts", postId);
        const snap = await getDoc(postRef);
        if (!snap.exists()) return;

        // 1. 전체 댓글 배열 가져오기
        const data = snap.data();
        let comments = data.comments || [];

        // 2. 해당 댓글(부모) 찾기
        if (!comments[parentIndex]) return;

        // 3. replies 배열이 없으면 만들기
        if (!comments[parentIndex].replies) {
            comments[parentIndex].replies = [];
        }

        // 4. 답글 추가
        comments[parentIndex].replies.push({
            userId: currentUserId,
            user: window.ShopifyInfo.currentUser || "User",
            // 유령 계정(Ghost)이거나 실제 유저의 프로필 사진이 있으면 추가
            avatarUrl: "", // (필요하다면 유저 프로필 이미지 연동 가능)
            text: text,
            date: new Date().toISOString()
        });

        // 5. 업데이트
        await updateDoc(postRef, { comments: comments });

        // 6. 새로고침
        loadComments(postId);

    } catch (e) {
        console.error("Reply Error:", e);
        alert("Error saving reply.");
    }
};

//댓글 삭제 함수
window.deleteComment = async function(postId, index) {
    if(!confirm("本当にこのコメントを削除しますか？")) return;

    try {
        const postRef = doc(db, "posts", postId);
        
        // 1. 현재 게시글 데이터 가져오기 (배열 조작을 위해)
        const snap = await getDoc(postRef);
        if (!snap.exists()) return;

        let comments = snap.data().comments || [];

        // 2. 해당 인덱스의 댓글 삭제
        // (배열에서 index 위치의 항목 1개를 제거)
        comments.splice(index, 1);

        // 3. 변경된 배열을 다시 저장
        await updateDoc(postRef, { comments: comments });

        // 4. 화면 새로고침 (댓글 목록 다시 로드)
        loadComments(postId);

    } catch(e) {
        console.error("Delete Error:", e);
        alert("エラーが発生しました。");
    }
};

//답글 삭제 함수
window.deleteReply = async function(postId, parentIndex, replyIndex) {
    if(!confirm("この返信を削除しますか？")) return;

    try {
        const postRef = doc(db, "posts", postId);
        const snap = await getDoc(postRef);
        if (!snap.exists()) return;

        let comments = snap.data().comments || [];
        
        // 해당 댓글의 답글 배열에서 삭제
        if (comments[parentIndex] && comments[parentIndex].replies) {
            comments[parentIndex].replies.splice(replyIndex, 1);
            
            await updateDoc(postRef, { comments: comments });
            loadComments(postId);
        }

    } catch(e) {
        console.error("Delete Reply Error:", e);
    }
};

// [최종 수정] 삭제 후 화면 목록까지 즉시 갱신하는 함수
window.deletePost = async function(postId) {
    if (!confirm("削除しますか？復旧はできません。\n(This cannot be undone.)")) return;

    try {
        // 1. 파이어베이스에서 진짜 삭제
        await deleteDoc(doc(db, "posts", postId));
        alert("完全に削除しました。");

        // 2. [핵심] 내 브라우저에 저장된 목록에서도 해당 글 제거 (새로고침 없이 반영)
        if (window.allFetchedPosts) {
            window.allFetchedPosts = window.allFetchedPosts.filter(p => p.id !== postId);
        }
        if (window.allPosts) {
            window.allPosts = window.allPosts.filter(p => p.id !== postId);
        }

        // 3. 화면 다시 그리기 (삭제된 글 빼고 렌더링)
        if (typeof window.applyFilters === 'function') {
            window.applyFilters();
        }

        // 4. 상세 페이지였다면 갤러리로 복귀
        if (!document.getElementById('detailView').classList.contains('hidden')) {
            window.goToGallery ? window.goToGallery() : location.reload();
        }

    } catch (e) {
        console.error("Delete error:", e);
        alert("削除に失敗しました。");
    }
};

// [Admin] 게시글 고정/해제 (Pin)
window.togglePin = async function(postId, currentStatus) {
    if (!confirm(currentStatus ? "この投稿の固定を解除しますか？" : "この投稿をトップに固定しますか？")) return;
    try {
        const postRef = doc(db, "posts", postId);
        await updateDoc(postRef, { isPinned: !currentStatus });
        alert(currentStatus ? "固定を解除しました。" : "固定しました！");
        location.reload(); // 새로고침해서 반영
    } catch (e) {
        console.error("Pin error:", e);
        alert("エラーが発生しました。");
    }
};




// 1. [기존 localSearch 수정] 검색 결과 클릭 시 새 시스템(confirmSelection)을 호출하도록 변경
window.localSearch = function(input, id) {
    const keyword = input.value.toLowerCase();
    const resBox = document.getElementById(`res_${id}`);
    if(keyword.length < 2) { resBox.style.display = 'none'; return; }
    
    const products = window.fhProducts || [];
    const results = products.filter(p => p.title.toLowerCase().includes(keyword));
    resBox.innerHTML = "";
    
    if(results.length > 0) {
      resBox.style.display = 'block';
      results.slice(0, 50).forEach(p => {
        const item = document.createElement('div');
        item.className = 'fh-result-item';
        item.innerHTML = `<img src="${p.image}" style="width:30px;height:30px;object-fit:cover;"> <div>${p.title}</div>`;
        item.onclick = () => {
            window.currentSectionId = id; 
            if(!window.tempCoords) window.tempCoords = { x: 50, y: 50 }; 
            window.confirmSelection(p);
            resBox.style.display = 'none';
        };
        resBox.appendChild(item);
      });
    } else { resBox.style.display = 'none'; }
};







  





window.handlePwInput = function(el) {
  el.value = el.value.replace(/[^0-9]/g, '').slice(0, 4);
};

window.togglePwVisibility = function() {
  const input = document.getElementById('postPassword');
  const btn = document.querySelector('.fh-pw-toggle');
  if (input.type === 'password') { input.type = 'text'; btn.innerText = '🔒'; }
  else { input.type = 'password'; btn.innerText = '👁️'; }
};







/* ==========================================================================
   SECTION 7. HELPERS & UTILITIES
   - 포맷팅, 검색 필터, 모바일 시트, 공유 등 보조 기능
   ========================================================================== */


// 7-1 필터 & 검색

// [필터 & 정렬 적용] 최종 완성본
window.applyFilters = function() {
    if (window.location.pathname.includes('qna') || !document.getElementById('filterDateStart')) {
        return; 
    }
    // 1. [데이터 소스 통합] 어떤 변수에든 담긴 최신 데이터를 가져옵니다.
    const rawData = (window.allFetchedPosts && window.allFetchedPosts.length > 0) 
                    ? window.allFetchedPosts 
                    : window.allPosts;

    // 데이터가 아예 로딩 전이라면 메시지 없이 대기합니다.
    if (!rawData || rawData.length === 0) {
        console.log("Waiting for data load...");
        return;
    }

    // 2. 필터링 시작 (원본 데이터 복사)
    let result = [...rawData];
    
    // ============================================================
    // ★ [업데이트] 검색어(searchKeyword) 필터링 로직 (통합 + 하위호환)
    // ============================================================
    if (searchKeyword && searchKeyword.trim() !== "") {
        const key = searchKeyword.toLowerCase().trim();
        result = result.filter(p => {
            // 1. 신규 게시글: 통합 검색 필드 (searchText) 하나로 끝!
            if (p.searchText && p.searchText.includes(key)) {
                return true;
            }

            // 2. 구형 게시글 (searchText가 없는 과거 글)을 위한 하위 호환 로직
            const titleMatch = p.title && p.title.toLowerCase().includes(key);
            const userMatch = p.user && p.user.toLowerCase().includes(key);
            let textOrPinMatch = false;

            if (p.content) {
                p.content.forEach(c => {
                    // 본문 텍스트 검사
                    if (c.text && c.text.toLowerCase().includes(key)) textOrPinMatch = true;
                    // 태그된 제품명 검사
                    if (c.products) {
                        c.products.forEach(prod => {
                            if (prod.title && prod.title.toLowerCase().includes(key)) textOrPinMatch = true;
                        });
                    }
                    // 핀(Hotspot) 제품명 검사
                    if (c.hotspots) {
                        c.hotspots.forEach(hot => {
                            if (hot.title && hot.title.toLowerCase().includes(key)) textOrPinMatch = true;
                        });
                    }
                });
            }
            
            return titleMatch || userMatch || textOrPinMatch;
        });
    }
    // ============================================================
    // ============================================================

    // 2. 드롭다운 필터값 가져오기
    let sortType = 'newest';
    let structureVal = 'all';
    let sizeVal = 'all';

    try {
        const sortEl = document.querySelector('.fh-dropdown[data-type="sort"] .selected');
        if (sortEl) {
            const match = sortEl.getAttribute('onclick').match(/'sort',\s*'([^']+)'/);
            if (match) sortType = match[1];
        }
        const strucEl = document.querySelector('.fh-dropdown[data-type="structure"] .selected');
        if (strucEl) {
            const match = strucEl.getAttribute('onclick').match(/'structure',\s*'([^']+)'/);
            if (match) structureVal = match[1];
        }
        const sizeEl = document.querySelector('.fh-dropdown[data-type="size"] .selected');
        if (sizeEl) {
            const match = sizeEl.getAttribute('onclick').match(/'size',\s*'([^']+)'/);
            if (match) sizeVal = match[1];
        }
    } catch (e) { console.warn("Filter parsing error", e); }

    // 3. 카테고리 필터링
    if (structureVal !== 'all') result = result.filter(p => p.structure === structureVal);
    if (sizeVal !== 'all') result = result.filter(p => p.size === sizeVal);

    // 날짜 필터
    const dateStart = document.getElementById('filterDateStart').value;
    const dateEnd = document.getElementById('filterDateEnd').value;
    if (dateStart) result = result.filter(p => new Date(p.date) >= new Date(dateStart));
    if (dateEnd) {
        const ed = new Date(dateEnd);
        ed.setHours(23, 59, 59);
        result = result.filter(p => new Date(p.date) <= ed);
    }
    
    // 팔로잉 필터
    const isFollowing = document.getElementById('filterFollowing')?.classList.contains('active');
    if (isFollowing && currentUserId && currentUserId !== 'Guest') {
        // ID 문자열 변환 안전장치
        const myFollowing = (window.currentUserFollowing || []).map(id => String(id));
        result = result.filter(p => myFollowing.includes(String(p.userId)));
    }

    // 동영상 필터
    const isVideo = document.getElementById('filterVideo')?.classList.contains('active');
    if (isVideo) result = result.filter(p => p.content.some(c => c.type === 'video'));

    // [정렬 로직 수정]
    result.sort((a, b) => {
        // 0순위: 고정글(isPinned) 무조건 최상단
        const pinA = a.isPinned ? 1 : 0;
        const pinB = b.isPinned ? 1 : 0;
        if (pinA !== pinB) return pinB - pinA;

        // 1순위: 선택된 정렬 방식 적용
        if (sortType === 'likes_monthly') {
            // 한달 인기순: 좋아요 수 내림차순 -> 날짜 내림차순
            const likesA = a.likes ? a.likes.length : 0;
            const likesB = b.likes ? b.likes.length : 0;
            if (likesA !== likesB) return likesB - likesA;
            return new Date(b.date) - new Date(a.date);
        } else if (sortType === 'likes_all') {
            // 전체 인기순: 좋아요 수 내림차순 -> 날짜 내림차순
            const likesA = a.likes ? a.likes.length : 0;
            const likesB = b.likes ? b.likes.length : 0;
            if (likesA !== likesB) return likesB - likesA;
            return new Date(b.date) - new Date(a.date);
        } else {
            // 최신순 (기본): 날짜 내림차순
            return new Date(b.date) - new Date(a.date);
        }
    });

    // 트렌딩(likes_monthly) 선택 시 날짜 제한을 주고 싶다면 위 sort 직전에 아래 코드를 넣어주세요.
    if (sortType === 'likes_monthly') {
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        // 고정글이거나, 30일 이내인 글만 남김
        result = result.filter(p => p.isPinned || new Date(p.date) >= thirtyDaysAgo);
    }

    // 5. 화면 그리기
    renderGalleryGrid(result);
};

// [드롭다운] 필터 UI 제어
window.toggleDropdown = function(btn) {
  const dropdown = btn.closest('.fh-dropdown');
  document.querySelectorAll('.fh-dropdown').forEach(d => {
    if(d !== dropdown) d.classList.remove('open');
  });
  dropdown.classList.toggle('open');
}

window.closeAllDropdowns = function() {
    document.querySelectorAll('.fh-dropdown.open').forEach(d => d.classList.remove('open'));
    if (typeof closeBottomSheet === 'function') {
        closeBottomSheet();
    }
    document.querySelectorAll('.fh-dropdown-menu.fh-mobile-active').forEach(m => {
        const parentId = m.dataset.originalParent;
        const parent = document.getElementById(parentId);
        if(parent) parent.appendChild(m); 
        m.classList.remove('fh-mobile-active');
    });
}

window.handleSearch = function(input, event) {
    searchKeyword = input.value.toLowerCase().trim();
    const detailView = document.getElementById('detailView');
    const isDetailOpen = !detailView.classList.contains('hidden');

    if (isDetailOpen) {
        if (event.key === 'Enter') {
            closeDetail();  
            applyFilters(); 
            input.blur();   
        }
    } else {
        applyFilters();
    }
}

// [필터] 값 설정 및 적용
window.setFilter = function(type, value, item) {
  currentFilters[type] = value;
  const menu = item.closest('.fh-dropdown-menu');
  if(menu) {
     menu.querySelectorAll('.fh-menu-item').forEach(i => i.classList.remove('selected'));
     item.classList.add('selected');
     item.closest('.fh-dropdown').classList.remove('open');
  }
  const originalDropdown = document.querySelector(`.fh-dropdown[data-type="${type}"]`);
  if(originalDropdown) {
      const items = originalDropdown.querySelectorAll('.fh-menu-item');
      items.forEach(i => {
          if(i.getAttribute('onclick').includes(`'${value}'`)) i.classList.add('selected');
          else i.classList.remove('selected');
      });
  }
  closeBottomSheet(); 
  applyFilters();
}

window.toggleVideoFilter = function() {
  const btn = document.getElementById('filterVideo');
  btn.classList.toggle('active');
  currentFilters.video = btn.classList.contains('active');
  applyFilters();
};

window.toggleFollowingFilter = function() {
    if(!currentUserId) {
        if(confirm("ログインが必要です。(Login required)")) goToLogin();
        return;
    }
    const btn = document.getElementById('filterFollowing');
    btn.classList.toggle('active');
    currentFilters.following = btn.classList.contains('active');
    applyFilters();
}

// Mobile & Dropdown Logic
window.openFilter = function(type, btn) {
    if(window.innerWidth > 768) {
        toggleDropdown(btn);
    } else {
        const dropdown = btn.closest('.fh-dropdown');
        const menuHtml = dropdown.querySelector('.fh-dropdown-menu').innerHTML;
        openBottomSheet(menuHtml);
    }
}

// [검색] 태그 클릭 시 검색 실행 
window.searchTag = function(tag) {
    const input = document.querySelector('.fh-new-search-inp');
    if(input) input.value = tag;
    searchKeyword = tag.toLowerCase().trim();
    applyFilters();
    closeDetail(); 
}

// 7-2 모바일 바텀시트
window.openBottomSheet = function(contentHtml) {
    const sheet = document.getElementById('fh-mobile-sheet');
    const backdrop = document.getElementById('fh-mobile-backdrop');
    sheet.innerHTML = contentHtml;
    backdrop.classList.add('show');
    sheet.classList.add('show');
    //document.body.style.overflow = 'hidden'; 
}

// 1. 메뉴 열기 (점 3개 클릭 시 모바일 바텀시트 호출)
window.showMobilePostMenu = function(postId) {
    const d = window.currentPostData; 
    const isAdmin = window.ShopifyInfo?.isAdmin;
    
    // [권한 분기] 관리자일 경우에만 '고정/해제' 버튼 HTML 추가
    let pinBtnHtml = '';
    if (isAdmin && d) {
        const isPinned = d.isPinned === true;
        const pinLabel = isPinned ? "📌 固定解除 (Unpin)" : "📍 トップに固定 (Pin)";
        pinBtnHtml = `<div class="fh-sheet-btn" onclick="togglePin('${postId}', ${isPinned}); closeBottomSheet();">${pinLabel}</div>`;
    }

    // 바텀시트 내용물 조립
    const sheetHtml = `
        <div style="padding:15px; text-align:center; font-size:12px; color:#aaa; border-bottom:1px solid #eee;">Post Menu</div>
        ${pinBtnHtml}
        <div class="fh-sheet-btn" onclick="editPost('${postId}'); closeBottomSheet();">編集 (Edit)</div>
        <div class="fh-sheet-btn delete" style="color:#ff3b30;" onclick="deletePost('${postId}'); closeBottomSheet();">削除 (Delete)</div>
        <div class="fh-sheet-btn cancel" style="color:#888; background:#f9f9f9; border-bottom:none;" onclick="closeBottomSheet()">キャンセル (Cancel)</div>
    `;

    // HTML에 꽂아 넣고 애니메이션(.show) 켜기 + 스크롤 잠금
    const sheet = document.getElementById('fh-mobile-sheet');
    const backdrop = document.getElementById('fh-mobile-backdrop');
    
    if(sheet && backdrop) {
        sheet.innerHTML = sheetHtml;
        backdrop.classList.add('show');
        sheet.classList.add('show');
        document.body.style.overflow = 'hidden'; // 뒷배경 스크롤 완벽 차단!
    }
};

// 2. 바텀시트 닫기 통합 함수 (취소/배경 클릭 시)
window.closeBottomSheet = function() {
    const sheet = document.getElementById('fh-mobile-sheet');
    const backdrop = document.getElementById('fh-mobile-backdrop');
    
    if(sheet) sheet.classList.remove('show');
    if(backdrop) backdrop.classList.remove('show');
    document.body.style.overflow = ''; // 스크롤 잠금 해제!
};

// [추가] 점 3개 메뉴 토글 함수
window.togglePostMenu = function() {
    const menu = document.getElementById('postMenuDropdown');
    if (menu) {
        // hidden 클래스를 넣었다 뺐다 합니다.
        if (menu.classList.contains('hidden')) {
            menu.classList.remove('hidden');
            menu.style.display = 'block'; // 확실하게 보이게 함
        } else {
            menu.classList.add('hidden');
            menu.style.display = 'none';
        }
    }
};

// 2. 메뉴 닫기 (취소/배경 클릭 시)


// [네비게이션] 화면이동
window.goToGallery = async function() {
    // 1. 주소창 복구 및 탭 이름 초기화
    const cleanUrl = window.location.pathname;
    window.history.pushState({ path: cleanUrl }, '', cleanUrl);
    document.title = "COMMUNITY | FurniHunter";

    // 2. 불필요한 화면 끄기
    const hideElements = ['detailView', 'editorView', 'userProfileView', 'stickyActions'];
    hideElements.forEach(id => {
        const el = document.getElementById(id);
        if(el) { el.classList.add('hidden'); el.style.display = 'none'; }
    });

    // 3. 메인 갤러리 켜기
    const showElements = ['galleryView', 'filterBar', 'gridContainer', 'bestInteriorSection', 'popularProductsSection', 'dailyThemeSection'];
    showElements.forEach(id => {
        const el = document.getElementById(id);
        if(el) { el.classList.remove('hidden'); el.style.display = ''; }
    });

    // 4. 상단 배너 & 퀵 메뉴 완벽 복구
    const presentBar = document.querySelector('.fh-present-bar');
    const titleWrap = document.querySelector('.fh-title-wrapper');
    const mainHeader = document.getElementById('mainHeader');
    const searchWrap = document.querySelector('.fh-search-wrapper'); // 검색창도 여기서 처리

    if(presentBar) presentBar.style.display = '';
    if(titleWrap) titleWrap.style.display = '';
    if(searchWrap) searchWrap.style.display = '';
    
    if(mainHeader) {
        mainHeader.style.display = '';
        // ★ [핵심] 브라우저 정렬 버그를 깨기 위해 버튼 강제 리렌더링!
        if(typeof window.renderAuthButtons === 'function') window.renderAuthButtons();
    }

    // 5. 모바일 바텀시트 및 플로팅 버튼 복구
    if (typeof closeBottomSheet === 'function') closeBottomSheet();
    const fabBtn = document.getElementById('fabWriteBtn');
    if(fabBtn) fabBtn.classList.remove('hide-fab');

    // 6. 데이터 없으면 다시 불러오기 (빈 화면 방지)
    if (!window.allFetchedPosts || window.allFetchedPosts.length === 0) {
        if (typeof showTopProgressBar === 'function') showTopProgressBar(true);
        if (typeof loadGallery === 'function') await loadGallery();
        if (typeof showTopProgressBar === 'function') showTopProgressBar(false);
    } else {
        if (typeof window.applyFilters === 'function') window.applyFilters();
        if (typeof window.renderMonthlyBest === 'function') window.renderMonthlyBest(window.allFetchedPosts);
        if (typeof window.renderBestInterior === 'function') window.renderBestInterior(window.allFetchedPosts);
        if (typeof window.renderPopularProducts === 'function') window.renderPopularProducts(window.allFetchedPosts);
        if (typeof window.renderDailyThemeSection === 'function') window.renderDailyThemeSection(window.allFetchedPosts);
    }

    // 7. 화면 맨 위로
    window.scrollTo(0, 0);
};

window.closeDetail = () => {
    // 낡은 복구 로직은 다 버리고, 완벽하게 세팅된 무적의 goToGallery 하나로 통일합니다!
    if(typeof goToGallery === 'function') goToGallery();
};

window.goToLogin = function() {
    window.location.href = window.ShopifyInfo.loginUrl + "?checkout_url=" + encodeURIComponent(window.location.pathname + window.location.search);
}

// [공유] 현재 페이지 링크 복사
window.shareCurrentPost = function(btn) {
    // 클릭 효과
    if(window.triggerPopEffect) window.triggerPopEffect(window.event);

    // [수정] currentPostId가 없으면 window에서라도 가져옴
    const targetId = currentPostId || window.currentPostId;
    if(!targetId) return alert("記事情報が見つかりません");

    // 공유용 URL 생성
    let shareUrl = window.location.origin + window.location.pathname + '?post_id=' + targetId;

    // 클립보드 복사 실행
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareUrl).then(() => {
            alert("リンクをコピーしました！ ✨\n(Link copied)");
        }).catch(err => {
            prompt("以下のリンクをコピーしてください:", shareUrl);
        });
    } else {
        // 구형 브라우저 대응
        const tempInput = document.createElement('input');
        tempInput.value = shareUrl;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        alert("リンクをコピーしました！ ✨");
    }
};

// 7-3 스크롤 및 기타
// [수정] 이중 스크롤 대응 버전 (scrollIntoView 사용)
window.scrollToComments = function() {
    const commentArea = document.getElementById('commentSection'); 
    if (commentArea) {
        // scrollIntoView는 내부 스크롤바든 창 스크롤바든 상관없이 
        // 해당 요소를 화면 상단으로 부드럽게 가져옵니다.
        commentArea.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // 만약 상단 헤더에 글자가 가려진다면? 
        // 1초 뒤에 살짝 보정해주거나, 아래 CSS 팁을 적용하는 게 가장 깔끔합니다.
        console.log("내부 스크롤 이동 완료");
    } else {
        console.error("commentSection을 찾을 수 없습니다.");
    }
};

window.triggerScrollReveal = function() {
    setTimeout(() => {
        const cards = document.querySelectorAll('.fh-feed-card'); 
        
        if(cards.length === 0) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry, index) => {
                if (entry.isIntersecting) {
                    setTimeout(() => {
                        entry.target.classList.add('active');
                    }, index * 50); 
                    
                    observer.unobserve(entry.target); 
                }
            });
        }, { threshold: 0.1 }); 

        cards.forEach(card => {
            if(card.classList.contains('active')) return;
            card.classList.add('fh-reveal-card');
            observer.observe(card);
        });
    }, 100);
};

window.copyToClipboard = function(text) {
  navigator.clipboard.writeText(text).then(() => {
      alert("名前をコピーしました: " + text);
  });
}

// [텍스트] 해시태그 링크 변환
window.formatContent = function(text) {
    if(!text) return "";
    return text.replace(/(#[^\s#]+)/g, '<span class="fh-hashtag" onclick="searchTag(\'$1\'); event.stopPropagation();">$1</span>');
}

// [효과] 클릭 파티클 효과
window.triggerPopEffect = function(e) {
    const event = e || window.event;
    if (!event) return;

    const x = event.clientX;
    const y = event.clientY;

    const colors = ['#FF5733', '#FFC300', '#2ECC71', '#3498DB', '#E91E63'];

    for (let i = 0; i < 12; i++) {
        const particle = document.createElement('div');
        particle.classList.add('fh-click-particle');

        particle.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];

        particle.style.setProperty('--sx', x + 'px');
        particle.style.setProperty('--sy', y + 'px');

        const angle = Math.random() * Math.PI * 2; 
        const velocity = 30 + Math.random() * 50;  
        const tx = x + Math.cos(angle) * velocity;
        const ty = y + Math.sin(angle) * velocity;

        particle.style.setProperty('--ex', tx + 'px');
        particle.style.setProperty('--ey', ty + 'px');

        document.body.appendChild(particle);

        setTimeout(() => particle.remove(), 600);
    }
};

// [로딩바] 상단 진행바 제어
function showTopProgressBar(show) {
  let bar = document.getElementById('fh-top-bar');
  if (!bar) {
      bar = document.createElement('div');
      bar.id = 'fh-top-bar';
      bar.style.cssText = "position:fixed; top:0; left:0; height:3px; background:#000; z-index:100001; transition:width 0.4s ease; width:0; pointer-events:none;";
      document.body.appendChild(bar);
  }

  if (show) {
      bar.style.width = "0%";
      setTimeout(() => { bar.style.width = "70%"; }, 10);
  } else {
      bar.style.width = "100%";
      setTimeout(() => { 
          bar.style.opacity = "0";
          setTimeout(() => { bar.style.width = "0%"; bar.style.opacity = "1"; }, 400);
      }, 300);
  }
}

// [NEW] 숫자 포맷팅 (1200 -> 1.2k)
window.formatCount = function(num) {
    if (!num) return 0;
    if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    }
    return num;
};


// 7-4 베스트섹션
// [수정됨] 자동 스크롤 제어 함수 (터치 후 다시 재개되도록 개선)
let bestScrollInterval = null;
let bestScrollTimeout = null; // 재시작 타이머
function startBestAutoScroll() {
    const track = document.getElementById('bestTrack');
    if (!track) return;

    // 기존 인터벌/타이머 초기화
    if (window.bestScrollInterval) clearInterval(window.bestScrollInterval);
    if (window.bestScrollTimeout) clearTimeout(window.bestScrollTimeout);

    const runScroll = () => {
        const card = track.querySelector('.fh-best-card');
        if (!card) return;
        
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.gap) || 12; 
        const scrollAmount = card.offsetWidth + gap; 

        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
            track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    // 바로 setInterval을 돌리지 않고 setTimeout으로 한 박자 늦춥니다.
    window.bestScrollTimeout = setTimeout(() => {
        window.bestScrollInterval = setInterval(runScroll, 3000);
    }, 3000); 

    // [핵심 수정 2] 멈춤 및 재개 로직 단일화
    const stopAuto = () => {
        clearInterval(window.bestScrollInterval);
        clearTimeout(window.bestScrollTimeout);
    };

    const resumeAuto = () => {
        stopAuto();
        // 조작이 멈추고 3초 뒤부터 다시 자동 스크롤 가동
        window.bestScrollTimeout = setTimeout(() => {
            window.bestScrollInterval = setInterval(runScroll, 3000);
        }, 3000);
    };

    // 3. 이벤트 리스너 등록
    // 마우스 올리면 멈추고, 떼면 다시 시작하는 직관적인 기능 추가
    track.addEventListener('mouseenter', stopAuto);
    track.addEventListener('mouseleave', resumeAuto);

    // 모바일 터치 및 휠 조작 대응
    track.addEventListener('touchstart', stopAuto, { passive: true });
    track.addEventListener('touchend', resumeAuto, { passive: true });
    track.addEventListener('mousedown', stopAuto);
    track.addEventListener('mouseup', resumeAuto);
    track.addEventListener('wheel', () => {
        stopAuto();
        resumeAuto(); // 휠 조작 중에는 계속 타이머 리셋
    }, { passive: true });
}


//7-5 모바일 검색모달 로직
// 스와이프로 닫기 구현
document.addEventListener('DOMContentLoaded', () => {
    const sheet = document.querySelector('.fh-search-sheet');
    const list = document.getElementById('globalSearchResult');
    
    if (!sheet || !list) return;

    let startY = 0;
    let currentY = 0;
    let isDragging = false;

    // 1. 터치 시작 (좌표 저장)
    sheet.addEventListener('touchstart', (e) => {
        // 리스트가 스크롤되어 내려가 있는 상태라면 스와이프 닫기 방지 (내부 스크롤 우선)
        if (list.scrollTop > 0 && e.target.closest('.fh-sheet-list')) return;

        startY = e.touches[0].clientY;
        isDragging = true;
        sheet.style.transition = 'none'; // 드래그 중에는 애니메이션 끔 (즉각 반응)
    }, { passive: true });

    // 2. 터치 이동 (화면 따라오기)
    sheet.addEventListener('touchmove', (e) => {
        if (!isDragging) return;

        const touchY = e.touches[0].clientY;
        const diff = touchY - startY;

        // 아래로 내릴 때만 작동 (diff > 0)
        if (diff > 0) {
            // ★ [수정] 이 줄이 있어야 뒷 배경이 안 움직입니다!
            if (e.cancelable) e.preventDefault(); 
            
            sheet.style.transform = `translateY(${diff}px)`;
            currentY = diff;
        }
    }, { passive: false }); // ★ passive: false가 필수입니다

    // 3. 터치 종료 (닫을지, 되돌릴지 결정)
    sheet.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        sheet.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)'; // 애니메이션 복구

        // 120px 이상 내렸으면 닫기, 아니면 원위치
        if (currentY > 120) {
            window.closeSearchModal();
        } else {
            sheet.style.transform = ''; // CSS 원상복구 (translateY(0))
        }
        
        currentY = 0; // 초기화
    });
});

// [모달 내부] 리스트 렌더링
window.renderModalList = function(items) {
    const list = document.getElementById('globalSearchResult');
    if(!list) return;
    list.innerHTML = "";
    items.forEach(p => {
        const div = document.createElement('div');
        div.className = 'fh-sheet-item';
        div.innerHTML = `
            <img src="${p.image}" class="fh-sheet-img">
            <div style="flex:1;">
                <div style="font-weight:600; font-size:14px;">${p.title}</div>
                <div style="font-size:12px; color:#888;">Select Product</div>
            </div>
        `;
        // 클릭 시 선택 확정
        div.onclick = () => window.confirmSelection(p);
        list.appendChild(div);
    });
};

// 검색 기능
window.handleGlobalSearch = function(input) {
    const keyword = input.value.toLowerCase().trim();
    if(!keyword) {
        renderModalList(window.fhProducts.slice(0, 30));
        return;
    }
    const filtered = window.fhProducts.filter(p => p.title.toLowerCase().includes(keyword));
    renderModalList(filtered);
};

// [모달] 닫기 통합 함수 (배경 클릭, 스크롤 잠금 해제, 시트 초기화)
window.closeSearchModal = function(e) {
    // 1. 배경(backdrop) 클릭인지 확인 (이벤트 객체가 넘어온 경우만)
    if (e && e.target && !e.target.classList.contains('fh-search-modal-backdrop')) return;
    
    // 2. 모달 숨기기
    const modal = document.getElementById('productSearchModal');
    if(modal) modal.classList.remove('show');
    
    // 3. 배경 스크롤 잠금 해제 (필수)
    document.body.style.overflow = ''; 

    // 4. 임시 핀(선택 중이던 파동) 제거
    if(window.currentSectionId) {
        const temp = document.querySelector(`#container_${window.currentSectionId} .fh-temp-pin`);
        if(temp) temp.remove();
    }

    // 5. 모바일 바텀 시트 위치/애니메이션 초기화
    const sheet = document.querySelector('.fh-search-sheet');
    if(sheet) {
        setTimeout(() => {
            sheet.style.transform = ''; 
            sheet.style.transition = '';
        }, 300); // 닫히는 애니메이션(0.3s)이 끝난 뒤 실행
    }
};

// [추가] 메뉴 바깥을 클릭하면 닫히게 하기
window.addEventListener('click', function(e) {
    const menu = document.getElementById('postMenuDropdown');
    const btn = document.querySelector('.fh-post-menu-btn');
    
    // 메뉴가 열려있고, 클릭한 곳이 메뉴나 버튼이 아니라면 닫기
    if (menu && !menu.classList.contains('hidden') && btn) {
        if (!e.target.closest('.fh-post-menu-wrap')) {
            menu.classList.add('hidden');
            menu.style.display = 'none';
        }
    }
});


// [최종 수정] 스크롤 이벤트 (상세 페이지가 진짜 보일 때만 하단 바 작동)
let lastScrollY = window.scrollY;
window.addEventListener('scroll', () => {
    const mobBar = document.getElementById('mobileStickyBar');
    const fabBtn = document.getElementById('fabWriteBtn');
    const detailView = document.getElementById('detailView'); // 상세페이지 요소 가져오기
    
    // ★ 핵심 수정: 모바일 바가 있고 + "상세 페이지가 현재 눈에 보일 때(!hidden)"만 작동
    if (mobBar && detailView && !detailView.classList.contains('hidden')) {
        
        // (안전장치) 만약 메인 화면인데 실수로 클래스가 남아있다면 강제로 제거
        if (!mobBar.classList.contains('show')) {
             mobBar.classList.add('show');
        }

        const currentScrollY = window.scrollY;

        // 1. 아래로 스크롤: 하단바 숨기고 글작성 버튼 보이기
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
            mobBar.classList.add('hide-bar');
            if (fabBtn) fabBtn.classList.remove('hide-fab');
        } 
        // 2. 위로 스크롤: 하단바 보이고 글작성 버튼 숨기기
        else {
            mobBar.classList.remove('hide-bar');
            if (fabBtn) fabBtn.classList.add('hide-fab');
        }

        lastScrollY = currentScrollY;

    } else {
        // ★ 메인 화면(갤러리)이거나 다른 화면일 때는
        // 하단 바를 무조건 숨기고, 글쓰기 버튼은 보여줌
        if (mobBar) {
            mobBar.classList.remove('show');
            mobBar.classList.remove('hide-bar'); // 숨김 상태 클래스도 초기화
        }
        if (fabBtn) fabBtn.classList.remove('hide-fab');
    }
});





























// 1. 브라우저의 강제 스크롤 복원 기능 끄기 (무조건 맨 위로 가도록)
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}


///////////
// 페이지 로드 시 실행 (이 부분이 맨 아래에 있어야 합니다)
document.addEventListener("DOMContentLoaded", () => {
    // [FIX] 댓글 '投稿' 버튼 클릭 이벤트 연결
    const btnPost = document.getElementById('btnPostComment');
    if (btnPost) {
        // 클릭하면 현재 보고 있는 게시글(currentPostId)에 댓글 저장 실행
        btnPost.onclick = () => window.saveComment(); 
    }
});